/* ─────────────────────────────────────────────────────────────
   Opora Edge — v2 APP SURFACE logic
   - Ask Opora: live streaming from /api/ask (fetch + ReadableStream)
   - 8 tool cards: expand/collapse, POST to worker, render results inline
   - Free-demo counters via COOKIES (localStorage is blocked in preview iframe)
   - Sign-up gate modal at limit
   - Validation, loading skeletons, friendly error states
   Does NOT touch styles.css / motion.js (other subagent owns those).
───────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var API_BASE = (typeof window !== 'undefined' && window.OporaEdge && window.OporaEdge.WORKER_URL)
    ? window.OporaEdge.WORKER_URL
    : ((typeof window !== 'undefined' && window.OPORA_WORKER_URL) ? window.OPORA_WORKER_URL : 'https://opora-ai.mshabliy.workers.dev');
  var ASK_FREE_LIMIT = 20;      // 20 free Ask questions / 30d rolling (per browser+IP) before gate
  var TOOL_FREE_LIMIT = 2;      // 2 free completed runs per tool / 30d rolling before gate
  function edgeCfg() { return (typeof window !== 'undefined' && window.OporaEdge) || {}; }
  function isUnlimited() {
    return !!(window.OPORA_QA_UNLIMITED || window.OPORA_ADMIN_UNLIMITED);
  }
  function DASHBOARD_SIGNIN() {
    var e = edgeCfg();
    return e.signInUrl ? e.signInUrl() : 'https://dashboard.oporasupply.com/';
  }
  function DASHBOARD_SIGNUP() {
    var e = edgeCfg();
    return e.signUpUrl ? e.signUpUrl() : 'https://dashboard.oporasupply.com/?intent=sign-up';
  }

  function openAuthModal(intent, opts) {
    if (window.OporaAuth && typeof window.OporaAuth.openModal === 'function' && !window.OporaAuth.__oporaStub) {
      var o = opts || {};
      window.OporaAuth.openModal({
        intent: intent || 'sign-in',
        inPlace: true,
        title: o.title,
        tagline: o.tagline,
        onAuthed: o.onAuthed || null
      });
      return true;
    }
    return false;
  }

  function dashboardLink(base) {
    return base;
  }

  var COOKIE_DAYS = 365;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Cookie store (localStorage forbidden in preview iframe) ── */
  var cookies = {
    get: function (key) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      return m ? parseInt(decodeURIComponent(m[1]), 10) || 0 : 0;
    },
    set: function (key, val) {
      var maxAge = COOKIE_DAYS * 24 * 60 * 60;
      try { document.cookie = key + '=' + encodeURIComponent(val) + '; path=/; max-age=' + maxAge + '; SameSite=Lax'; }
      catch (e) { /* blocked — fall back to in-memory */ this._mem = this._mem || {}; this._mem[key] = val; }
    }
  };

  /* ── Sanitizers ── */
  function clamp(str, max) { return String(str == null ? '' : str).slice(0, max); }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── Minimal, safe markdown → HTML (escape first, then format) ── */
  function isFinancialScaffoldSkipLine(line) {
    var t = String(line || '').trim();
    if (!t) return false;
    if (/^\*{0,2}Financial scaffolding\*{0,2}$/i.test(t)) return true;
    if (/^(?:\|\s*)?Metric\s*(?:\||\s{2,})\s*Calculation\s*\/\s*Breakdown/i.test(t)) return true;
    if (/^Target Rate\s*=\s*Base/i.test(t)) return true;
    if (/^[-|:\s]{3,}$/.test(t) && /\|/.test(t)) return false; /* handled by pipe-table path */
    if (/^(?:\|\s*)?(Base Direct (?:Wage|Labor)|Statutory Burden|Fully Burdened Cost|Gross Margin Divisor|Required Bill Rate|Markup Leakage)/i.test(t)) return true;
    return false;
  }
  function renderMarkdown(md) {
    if (!md) return '';
    var cleaned = String(md)
      .replace(/\r\n/g, '\n')
      /* Strip internal orchestration / sentinel lines before paint */
      .replace(/^[^\n]*⟦?\s*OPORA_RATE_STACK\s*⟧?[^\n]*$/gim, '')
      .replace(/^[^\n]*\[\[\s*OPORA_RATE_STACK\s*\]\][^\n]*$/gim, '')
      .replace(/_?Financial stack loads as a structured table[\s\S]*?_\n?/gi, '')
      .replace(/Financial stack loads as a structured table[^\n]*\n?/gi, '')
      /* Never paint ASCII / space-padded financial scaffolds — desk mounts a CSS grid */
      .replace(/\*{0,2}Financial scaffolding\*{0,2}\s*\n+/ig, '\n')
      .replace(/(?:\|\s*)?Metric\s*(?:\||\s{2,})\s*Calculation\s*\/\s*Breakdown\s*(?:\||\s{2,})\s*Value\s*(?:\||)?[\s\S]*?(?=\n\s*Target Rate|\n\s*\*{0,2}Compliance|\n\s*\*{0,2}SOW|\n\s*\*{0,2}Competitor|\n\s*\*{0,2}Risks|\n\s*\*{0,2}What to do|$)/ig, '\n')
      .replace(/\n\s*Target Rate\s*=\s*Base[^\n]*/ig, '\n');
    var lines = cleaned.split('\n');
    var html = [], i = 0;
    while (i < lines.length) {
      var line = lines[i];
      /* Never paint internal CTA tokens into the answer body */
      if (/[\[⟦]\s*OPORA_CTA\|/.test(line) || /^\s*OPORA_CTA\|/.test(line)) { i++; continue; }
      if (/OPORA_RATE_STACK|Financial stack loads as a structured table/i.test(line)) { i++; continue; }
      if (isFinancialScaffoldSkipLine(line)) { i++; continue; }
      var h = line.match(/^(#{1,4})\s+(.*)$/);
      if (h) { var lvl = Math.min(h[1].length + 1, 4); html.push('<h' + lvl + '>' + inline(h[2]) + '</h' + lvl + '>'); i++; continue; }
      if (/^---+$/.test(line.trim())) { html.push('<hr class="ask-md-hr">'); i++; continue; }
      /* Pipe tables: | a | b | */
      if (/^\s*\|.+\|\s*$/.test(line) && i + 1 < lines.length && /^\s*\|?\s*[-:| ]+\|\s*$/.test(lines[i + 1])) {
        var rows = [];
        while (i < lines.length && /^\s*\|.+\|\s*$/.test(lines[i])) {
          rows.push(lines[i]);
          i++;
        }
        if (rows.length >= 2) {
          function cells(row) {
            return row.replace(/^\s*\|/, '').replace(/\|\s*$/, '').split('|').map(function (c) { return c.trim(); });
          }
          var head = cells(rows[0]);
          var bodyRows = rows.slice(2);
          if (!/^\s*\|?\s*[-:| ]+\|\s*$/.test(rows[1])) bodyRows = rows.slice(1);
          var isFin =
            /Metric|Cost Component/i.test(head.join(' ')) ||
            bodyRows.some(function (r) { return /Base Direct|Fully Burdened|Gross Margin|Markup Leakage/i.test(r); });
          html.push(
            '<div class="ask-md-table-wrap' + (isFin ? ' ask-financial-table ask-ops-math--scaffold' : '') + '">' +
            '<table class="ask-md-table' + (isFin ? ' ask-scaffold ask-fin-table' : '') + '"><thead><tr>'
          );
          head.forEach(function (c) { html.push('<th>' + inline(c) + '</th>'); });
          html.push('</tr></thead><tbody>');
          bodyRows.forEach(function (r) {
            if (/^\s*\|?\s*[-:| ]+\|\s*$/.test(r)) return;
            var cols = cells(r);
            var rowClass = '';
            if (/Required Bill Rate|Gross Margin Divisor|Divisor/i.test(cols[0] || '')) rowClass = ' ask-fin-row--target';
            if (/Leakage/i.test(cols[0] || '')) rowClass = ' ask-fin-row--warn';
            if (/Fully Burdened/i.test(cols[0] || '')) rowClass = ' ask-fin-row--subtotal';
            html.push('<tr class="' + rowClass.trim() + '">');
            cols.forEach(function (c, ci) {
              html.push(ci === 0 ? '<th scope="row">' + inline(c) + '</th>' : '<td>' + inline(c) + '</td>');
            });
            html.push('</tr>');
          });
          html.push('</tbody></table></div>');
        }
        continue;
      }
      if (/^\s*[-*]\s+/.test(line)) {
        html.push('<ul>');
        while (i < lines.length && /^\s*[-*]\s+/.test(lines[i])) { html.push('<li>' + inline(lines[i].replace(/^\s*[-*]\s+/, '')) + '</li>'); i++; }
        html.push('</ul>'); continue;
      }
      if (/^\s*\d+\.\s+/.test(line)) {
        html.push('<ol>');
        while (i < lines.length) {
          if (/^\s*\d+\.\s+/.test(lines[i])) {
            html.push('<li>' + inline(lines[i].replace(/^\s*\d+\.\s+/, '')) + '</li>');
            i++;
          } else if (lines[i].trim() === '') {
            i++;
          } else {
            break;
          }
        }
        html.push('</ol>'); continue;
      }
      if (line.trim() === '') { i++; continue; }
      var para = [line]; i++;
      while (i < lines.length && lines[i].trim() !== '' && !/^(#{1,4})\s/.test(lines[i]) && !/^\s*[-*]\s/.test(lines[i]) && !/^\s*\d+\.\s/.test(lines[i]) && !/^---+$/.test(lines[i].trim()) && !/^\s*\|.+\|\s*$/.test(lines[i]) && !isFinancialScaffoldSkipLine(lines[i])) { para.push(lines[i]); i++; }
      /* Drop paragraphs that are only smashed financial-scaffold leftovers */
      var paraText = para.join(' ');
      if (/Financial scaffolding/i.test(paraText) && /Base Direct|Gross Margin Divisor/i.test(paraText)) { continue; }
      if (/Metric/.test(paraText) && /Calculation\s*\/\s*Breakdown/.test(paraText) && /Base Direct/i.test(paraText)) { continue; }
      html.push('<p>' + inline(paraText) + '</p>');
    }
    return html.join('');
    function inline(t) {
      var slots = [];
      t = String(t || '').replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (full, label, href) {
        if (!/^(https?:\/\/|\/pages\/|\/blogs\/)/i.test(href)) return full;
        var token = '@@ASKLINK' + slots.length + '@@';
        slots.push(
          '<a class="ask-md-link" href="' + escapeHtml(href) + '">' + escapeHtml(label) + '</a>'
        );
        return token;
      });
      t = escapeHtml(t);
      /* Bold / italic — non-greedy so headings like **Status** still paint after smash/restore. */
      t = t.replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>');
      t = t.replace(/__([^_\n]+?)__/g, '<strong>$1</strong>');
      t = t.replace(/(^|[^*])\*([^*\n]+?)\*(?!\*)/g, '$1<em>$2</em>');
      t = t.replace(/`([^`]+)`/g, '<code>$1</code>');
      t = t.replace(/@@ASKLINK(\d+)@@/g, function (_m, idx) {
        return slots[Number(idx)] || '';
      });
      return t;
    }
  }

  /* ── Business profile serializer (covers all field-name variants the worker validators expect) ── */
  function buildBusinessProfile(desc, extra) {
    desc = clamp(desc, 400).trim();
    var name = 'Your Company';
    var m = desc.match(/^([A-Z][\w&'.\- ]{1,48}?)(?:\s+[—–-]\s+|\s*[:,]\s+|\s+is\s+|$)/);
    if (m && m[1].trim().length > 1) name = m[1].trim();
    var profile = {
      company_name: name,
      brand_name: name,
      name: name,
      description: desc || 'A commercial cleaning company.',
      vertical: 'commercial',
      services_offered: ['janitorial', 'floor care', 'disinfection'],
      employee_count: 12,
      tone: 'professional'
    };
    if (extra) for (var k in extra) profile[k] = extra[k];
    return profile;
  }

  /* ── Gate modal ── */
  /* Self-inject the gate modal if the Liquid section did not render it.
     Sign-in / sign-up → dashboard.oporasupply.com (Clerk) with redirect back to tool page */
  (function injectGateModal() {
    if (document.getElementById('gateOverlay')) return; // already in DOM
    var el = document.createElement('div');
    el.innerHTML =
      '<div class="gate-overlay" id="gateOverlay" hidden>' +
        '<div class="gate" role="dialog" aria-modal="true" aria-labelledby="gateTitle" aria-describedby="gateBody">' +
          '<button class="gate-close" id="gateClose" aria-label="Close">×</button>' +
          '<span class="gate-eyebrow">Free demo used</span>' +
          '<h2 class="gate-title" id="gateTitle">You\u2019ve used your free demo.</h2>' +
          '<p class="gate-body" id="gateBody">Sign up free to keep using Opora Edge — full AI runs and every tool, grounded in cited sources.</p>' +
          '<div class="gate-actions">' +
            '<button type="button" class="btn btn--outline" id="gateSignInBtn">Sign in</button>' +
            '<button type="button" class="btn btn--primary btn--lg" id="gateSignUpBtn">Start free →</button>' +
          '</div>' +
          '<span class="cta-trust">No credit card needed.</span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el.firstChild);
  })();

  var gateOverlay = document.getElementById('gateOverlay');
  var gateClose = document.getElementById('gateClose');
  var lastFocus = null;
  function openGate() {
    if (isUnlimited()) return;
    if (!gateOverlay) return;
    lastFocus = document.activeElement;
    gateOverlay.hidden = false;
    var firstBtn = gateOverlay.querySelector('.btn');
    if (firstBtn) firstBtn.focus();
  }
  function closeGate() {
    if (!gateOverlay) return;
    gateOverlay.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (gateClose) gateClose.addEventListener('click', closeGate);
  if (gateOverlay) {
    gateOverlay.addEventListener('click', function (e) { if (e.target === gateOverlay) closeGate(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !gateOverlay.hidden) closeGate(); });
    var gsi = document.getElementById('gateSignInBtn');
    var gsu = document.getElementById('gateSignUpBtn');
    if (gsi) gsi.addEventListener('click', function () { closeGate(); if (!openAuthModal('sign-in')) window.location.href = dashboardLink(DASHBOARD_SIGNIN()); });
    if (gsu) gsu.addEventListener('click', function () { closeGate(); if (!openAuthModal('sign-up')) window.location.href = dashboardLink(DASHBOARD_SIGNUP()); });
  }

  /* ── Friendly error copy from status ── */
  function errorCopy(status, serverMsg) {
    if (status === 429) return { title: 'Free limit reached', body: "You've hit our free limit. Sign up free to keep going.", gate: true };
    if (status === 500 || status === 502 || status === 503) return { title: 'Our end', body: 'Something broke on our end. Please try again in a moment.' };
    if (status === 400 && serverMsg) return { title: 'Check your input', body: serverMsg, validation: true };
    if (status === 0) return { title: 'Connection', body: 'Something went wrong. Try again or contact support.' };
    return { title: 'Something went wrong', body: serverMsg || 'Something went wrong. Try again or contact support.' };
  }

  /* ════════════════════════════════════════════════════════════
     PRIMARY TOOL: ASK OPORA — live streaming
  ════════════════════════════════════════════════════════════ */
  (function askOpora() {
    var form = document.getElementById('askForm');
    var input = document.getElementById('askInput');
    var submit = document.getElementById('askSubmit');
    var counter = document.getElementById('askCounter');
    var thread = document.getElementById('askThread');
    var suggest = document.getElementById('askSuggest');
    var remainingEl = document.getElementById('askDemoRemaining');
    var section = document.getElementById('ask-section');
    var bodyheadLabel = document.getElementById('askBodyheadLabel');
    var submitLabel = submit && submit.querySelector('.ask-submit-label');
    var speedMeta = document.querySelector('.opora-desk__bodyhead-speed');
    if (!form || !input || !thread) return;

    /* Deep product removed — Ask-only desk. Strip legacy ?mode=deep deep-links. */
    function getAskMode() { return 'ask'; }

    function syncModeInUrl() {
      if (!window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('mode');
        u.searchParams.delete('ask_mode');
        u.searchParams.delete('deep');
        if ((u.hash || '').toLowerCase() === '#deep') u.hash = '#ask-section';
        window.history.replaceState({}, '', u.pathname + u.search + (u.hash || ''));
      } catch (e) {}
    }

    function setAskMode() {
      form.dataset.askMode = 'ask';
      if (bodyheadLabel) bodyheadLabel.textContent = 'Ask Opora — live workspace';
      if (submitLabel) submitLabel.textContent = 'Ask Opora';
      if (speedMeta) speedMeta.textContent = '< 2 sec response';
    }

    setAskMode();
    syncModeInUrl();

    /* In-session follow-ups for guests AND signed-in (same path — no auth gate).
       Storage: sessionStorage (dies with tab) + in-memory fallback when storage is blocked.
       New session button / closed tab wipe. Soft nav within the visit keeps history. */
    var ASK_HISTORY_KEY = 'opora_ask_thread_v1';
    var ASK_HISTORY_MAX_PAIRS = 6;
    /* Keep enough markdown structure for restore paint (paragraphs / bold / lists). */
    var ASK_HISTORY_ASSISTANT_CHARS = 4500;
    var _askHistMem = null;

    function loadAskHistory() {
      try {
        var raw = sessionStorage.getItem(ASK_HISTORY_KEY);
        if (raw) {
          var arr = JSON.parse(raw);
          if (Array.isArray(arr)) {
            _askHistMem = arr;
            return arr;
          }
        }
      } catch (e) {}
      return Array.isArray(_askHistMem) ? _askHistMem.slice() : [];
    }

    function persistAskHistory(arr) {
      var next = Array.isArray(arr) ? arr : [];
      _askHistMem = next;
      try {
        sessionStorage.setItem(ASK_HISTORY_KEY, JSON.stringify(next));
      } catch (e) {}
    }

    function stateCodeFromText(text) {
      if (!text) return null;
      if (window.OporaGeo) {
        try {
          var extractFn = OporaGeo.extractFromQuestion || OporaGeo.extract;
          var g = extractFn(String(text || ''));
          if (g && (g.state_code || g.state)) {
            var sc = String(g.state_code || g.state).toUpperCase().slice(0, 2);
            if (/^[A-Z]{2}$/.test(sc)) return sc;
          }
        } catch (e) {}
      }
      return null;
    }

    function getAskHistoryForRequest(currentQuestion) {
      var hist = loadAskHistory().slice(-(ASK_HISTORY_MAX_PAIRS * 2));
      if (!hist.length) return hist;
      var qState = stateCodeFromText(currentQuestion);
      var priorUser = '';
      for (var i = hist.length - 1; i >= 0; i--) {
        if (hist[i] && hist[i].role === 'user') {
          priorUser = hist[i].content || '';
          break;
        }
      }
      var priorState = stateCodeFromText(priorUser);
      /* Different explicit state than prior turn → cold ask (stops CA→TX poison). */
      if (qState && priorState && qState !== priorState) return [];
      var poisoned = hist.some(function (m) {
        return m && m.role === 'assistant' &&
          /only (provide|cover|handle|assist).{0,80}(specific to |for )?[A-Z]{2}\b|only (provide|cover).{0,40}(california|georgia|texas|florida|new york)/i.test(String(m.content || ''));
      });
      if (poisoned && qState && priorState && qState !== priorState) return [];
      if (poisoned && qState && !priorState) return [];
      return hist;
    }

    function compactAskHistoryAnswer(answer) {
      /* Preserve newlines so restore can render markdown; only collapse horizontal runs. */
      return String(answer || '')
        .replace(/\r\n/g, '\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/[ \t]{2,}/g, ' ')
        .trim()
        .slice(0, ASK_HISTORY_ASSISTANT_CHARS);
    }

    function appendAskHistoryPair(question, answer) {
      var hist = loadAskHistory();
      hist.push({ role: 'user', content: String(question || '').slice(0, 1200) });
      hist.push({
        role: 'assistant',
        content: compactAskHistoryAnswer(answer)
      });
      if (hist.length > ASK_HISTORY_MAX_PAIRS * 2) {
        hist = hist.slice(-(ASK_HISTORY_MAX_PAIRS * 2));
      }
      persistAskHistory(hist);
    }

    /* Soft-nav back to Ask: restore visible thread from session history (same for guest + member). */
    function rehydrateAskThreadFromHistory() {
      if (!thread || thread.querySelector('.ask-turn')) return;
      var hist = loadAskHistory();
      if (!hist.length) return;
      var i = 0;
      while (i < hist.length) {
        var u = hist[i];
        var a = hist[i + 1];
        if (!u || u.role !== 'user') { i++; continue; }
        var qText = String(u.content || '');
        var aText = (a && a.role === 'assistant') ? String(a.content || '') : '';
        var turn = document.createElement('div');
        turn.className = 'ask-turn ask-turn--restored';
        turn.innerHTML =
          '<div class="ask-q">' +
            '<span class="ask-q-icon" aria-hidden="true">Q</span>' +
            '<span class="ask-q-text"></span>' +
            '<span class="ask-q-label" aria-hidden="true">THIS SESSION</span>' +
          '</div>' +
          '<div class="ask-a"><div class="ask-a-split ask-a-split--band"><div class="ask-a-main"><div class="ask-a-body"></div></div></div></div>';
        turn.querySelector('.ask-q-text').textContent = qText;
        /* Same markdown path as live finalize — never dump escaped **…** as a wall of text. */
        var body = turn.querySelector('.ask-a-body');
        if (aText) {
          var paint = aText;
          /* Older history flattened newlines; soft-break before bold labels / lists. */
          if (!/\n/.test(paint)) {
            paint = paint
              .replace(/\s+(\*\*[^*\n]{1,80}\*\*)/g, '\n\n$1')
              .replace(/\s+(\d+\.\s+)/g, '\n$1')
              .replace(/\s+([-*]\s+)/g, '\n$1');
          }
          body.innerHTML = textWithCites(paint, []);
          hydrateRawMarkdownLinks(body);
          stripOporaCtaMarkers(body);
        } else {
          body.innerHTML = '<p></p>';
        }
        turn._askState = { question: qText, answer: aText, citations: [], meta: { restored: true } };
        thread.appendChild(turn);
        i += (a && a.role === 'assistant') ? 2 : 1;
      }
      if (suggest && thread.querySelector('.ask-turn')) suggest.hidden = true;
    }

    function syncNewThreadUi() {
      var btn = document.getElementById('askNewThread');
      var shellNew = document.getElementById('askShellNewSession');
      var hasTurns = !!(thread && thread.querySelector('.ask-turn'));
      var hasHist = loadAskHistory().length > 0;
      var show = !!(hasTurns || hasHist);
      if (btn) btn.hidden = !show;
      /* Left-rail "+ New query" stays visible in Workspace */
      if (shellNew) shellNew.hidden = false;
      refreshAskShell();
    }

    function startNewAskThread() {
      persistAskHistory([]);
      if (thread) thread.innerHTML = '';
      if (suggest) suggest.hidden = false;
      syncNewThreadUi();
      try {
        input.focus();
      } catch (e) {}
    }

    var ASK_CONTEXT_KEY = 'opora_ask_context_v1';

    function loadAskContext() {
      try {
        var raw = sessionStorage.getItem(ASK_CONTEXT_KEY);
        if (!raw) return {};
        var o = JSON.parse(raw);
        return o && typeof o === 'object' ? o : {};
      } catch (e) {
        return {};
      }
    }

    function persistAskContext(ctx) {
      try {
        sessionStorage.setItem(ASK_CONTEXT_KEY, JSON.stringify(ctx || {}));
      } catch (e) {}
    }

    function escapeShellText(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function inferContextFromText(text) {
      var t = String(text || '');
      var out = {};
      var st = stateCodeFromText(t);
      if (st) out.metro = st;
      var metro = t.match(/\b(Chicago|Houston|Dallas|Austin|Atlanta|Los Angeles|New York|Miami|Denver|Phoenix|Seattle|Boston)\b/i);
      if (metro) out.metro = metro[1] + (st ? ', ' + st : '');
      if (/\bclass\s*a\b/i.test(t)) out.buildingClass = 'A';
      else if (/\bclass\s*b\b/i.test(t)) out.buildingClass = 'B';
      else if (/\bclass\s*c\b/i.test(t)) out.buildingClass = 'C';
      else if (/\b(hospital|healthcare|OR|operating room)\b/i.test(t)) out.buildingClass = 'healthcare';
      else if (/\b(warehouse|industrial|plant)\b/i.test(t)) out.buildingClass = 'industrial';
      var sq = t.match(/(\d{1,3}(?:,\d{3})+|\d{4,7})\s*(?:sq\.?\s*ft|sqft|sf)\b/i);
      if (sq) out.sqft = sq[1].replace(/,/g, '');
      var nights = t.match(/(\d+)\s*nights?\s*(?:per|\/)\s*week/i);
      if (nights) out.contract = nights[1] + ' nights / week';
      return out;
    }

    function mergeContextFromTurn(question, citations) {
      var cur = loadAskContext();
      var inferred = inferContextFromText(question);
      Object.keys(inferred).forEach(function (k) {
        if (inferred[k] && !cur[k]) cur[k] = inferred[k];
      });
      persistAskContext(cur);
      paintAskShellContext(cur);
      paintAskShellSources(citations || []);
    }

    function paintAskShellContext(ctx) {
      ctx = ctx || loadAskContext();
      var metro = document.getElementById('askCtxMetro');
      var klass = document.getElementById('askCtxClass');
      var sqft = document.getElementById('askCtxSqft');
      var contract = document.getElementById('askCtxContract');
      var scope = document.getElementById('askCtxScope');
      if (metro && document.activeElement !== metro) metro.value = ctx.metro || '';
      if (klass && document.activeElement !== klass) klass.value = ctx.buildingClass || '';
      if (sqft && document.activeElement !== sqft) sqft.value = ctx.sqft || '';
      if (contract && document.activeElement !== contract) contract.value = ctx.contract || '';
      if (scope && document.activeElement !== scope) scope.value = ctx.scope || '';
    }

    function collectThreadCitations() {
      var all = [];
      var seen = {};
      if (!thread) return all;
      Array.prototype.forEach.call(thread.querySelectorAll('.ask-turn'), function (turn) {
        var cites = (turn._askState && turn._askState.citations) || [];
        Array.prototype.forEach.call(cites, function (c) {
          if (!c) return;
          var key = String((c.url || c.name || c.title || c.source || '')).toLowerCase().trim();
          if (!key) key = JSON.stringify(c).slice(0, 80);
          if (seen[key]) return;
          seen[key] = true;
          all.push(c);
        });
      });
      return all;
    }

    function paintAskShellRelated(citations) {
      var host = document.getElementById('askShellRelated');
      if (!host) return;
      var list = Array.isArray(citations) ? citations : [];
      var fg = [];
      var seen = {};
      list.forEach(function (c) {
        var url = c && c.url ? String(c.url) : '';
        if (!/\/blogs\/opora-field-guide\//i.test(url)) return;
        var key = url.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        fg.push(c);
      });
      if (!fg.length) {
        host.innerHTML = '<li><span>Field Guides linked from answers show here.</span></li>';
        return;
      }
      host.innerHTML = fg.slice(0, 8).map(function (c) {
        var title = escapeShellText((c && (c.title || c.name || c.source)) || 'Field Guide');
        var url = String(c.url || '');
        return '<li><a href="' + escapeShellText(url) + '" target="_blank" rel="noopener">' + title + '</a></li>';
      }).join('');
    }

    function paintAskShellSources(citations) {
      var host = document.getElementById('askShellSources');
      if (!host) return;
      /* Prefer full thread list so right rail accumulates across turns */
      var list = Array.isArray(citations) && citations.length
        ? citations
        : collectThreadCitations();
      if (!list.length) {
        host.innerHTML = '<li><span>Sources appear after an answer.</span></li>';
        paintAskShellRelated([]);
        return;
      }
      host.innerHTML = list.slice(0, 16).map(function (c, i) {
        var title = escapeShellText((c && (c.title || c.name || c.source)) || ('Source ' + (i + 1)));
        var url = c && c.url ? String(c.url) : '';
        var num = '<span class="ask-ws-src__num">[' + (i + 1) + ']</span>';
        if (url && /^(https?:\/\/|\/)/i.test(url)) {
          return '<li><a href="' + escapeShellText(url) + '" target="_blank" rel="noopener" title="' + title + '">' +
            num + title + '</a></li>';
        }
        return '<li><span title="' + title + '">' + num + title + '</span></li>';
      }).join('');
      paintAskShellRelated(list);
    }

    function refreshAskShell() {
      var list = document.getElementById('askShellSessionList');
      var empty = document.getElementById('askShellSessionEmpty');
      if (!list) return;
      var turns = thread ? thread.querySelectorAll('.ask-turn') : [];
      list.innerHTML = '';
      if (!turns.length) {
        list.hidden = true;
        if (empty) empty.hidden = false;
        paintAskShellContext();
        return;
      }
      if (empty) empty.hidden = true;
      list.hidden = false;
      Array.prototype.forEach.call(turns, function (turn, idx) {
        var qEl = turn.querySelector('.ask-q-text');
        var label = qEl ? String(qEl.textContent || '').trim() : '';
        if (!label) label = 'Turn ' + (idx + 1);
        if (label.length > 72) label = label.slice(0, 69) + '…';
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ask-shell-addon__session-item' + (turn.classList.contains('is-active-turn') ? ' is-active' : '');
        btn.textContent = label;
        btn.addEventListener('click', function () {
          try {
            turn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch (e) {}
          markActiveAskTurn(turn);
          var st = turn._askState || {};
          mergeContextFromTurn(st.question || label, st.citations || []);
          refreshAskShell();
        });
        li.appendChild(btn);
        list.appendChild(li);
      });
    }

    function bindAskShellControls() {
      var shellNew = document.getElementById('askShellNewSession');
      if (shellNew) {
        shellNew.addEventListener('click', function () {
          startNewAskThread();
          persistAskContext({});
          paintAskShellContext({});
          paintAskShellSources([]);
        });
      }
      ['askCtxMetro', 'askCtxClass', 'askCtxSqft', 'askCtxContract', 'askCtxScope'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        el.addEventListener('change', function () {
          var ctx = loadAskContext();
          ctx.metro = (document.getElementById('askCtxMetro') || {}).value || '';
          ctx.buildingClass = (document.getElementById('askCtxClass') || {}).value || '';
          ctx.sqft = (document.getElementById('askCtxSqft') || {}).value || '';
          ctx.contract = (document.getElementById('askCtxContract') || {}).value || '';
          ctx.scope = (document.getElementById('askCtxScope') || {}).value || '';
          persistAskContext(ctx);
        });
        el.addEventListener('input', function () {
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      paintAskShellContext();
      refreshAskShell();
    }

    bindAskShellControls();

    var newThreadBtn = document.getElementById('askNewThread');
    if (newThreadBtn) {
      newThreadBtn.addEventListener('click', function () {
        startNewAskThread();
        persistAskContext({});
        paintAskShellContext({});
        paintAskShellSources([]);
      });
    }
    /* Homepage / ?q= handoff starts a fresh thread — skip restore for that entry. */
    var _askHandoffPending = false;
    try {
      var _hq = (new URLSearchParams(window.location.search)).get('q');
      var _hs = '';
      try { _hs = sessionStorage.getItem('opora_ask_prompt') || ''; } catch (eH) {}
      _askHandoffPending = !!( (_hq && String(_hq).trim()) || (_hs && String(_hs).trim()) );
    } catch (eH2) {}
    if (_askHandoffPending) {
      persistAskHistory([]);
    } else {
      rehydrateAskThreadFromHistory();
    }
    syncNewThreadUi();

    function syncRemaining() {
      var used = cookies.get('opora_demo_ask');
      var left = Math.max(ASK_FREE_LIMIT - used, 0);
      if (remainingEl) remainingEl.textContent = left;
    }
    syncRemaining();

    function syncStackedField() {
      var field = input.closest('.opora-desk__field');
      if (!field) return;
      var v = String(input.value || '');
      var tall = false;
      try { tall = input.scrollHeight > 56; } catch (e) {}
      var stacked = v.length >= 100 || v.indexOf('\n') >= 0 || tall;
      field.classList.toggle('is-stacked', stacked);
    }
    function autosize() {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 360) + 'px';
      syncStackedField();
    }
    input.addEventListener('input', function () {
      counter.textContent = input.value.length + ' / 1200';
      autosize();
    });
    syncStackedField();

    // suggested pills
    if (suggest) suggest.addEventListener('click', function (e) {
      var btn = e.target.closest('.pill'); if (!btn) return;
      input.value = clamp(btn.dataset.prompt, 1200);
      counter.textContent = input.value.length + ' / 1200';
      autosize(); input.focus();
      if (window.OporaAskPlaybooks && typeof window.OporaAskPlaybooks.onComposerFill === 'function') {
        try { window.OporaAskPlaybooks.onComposerFill(input); } catch (err) {}
      }
    });

    // Citation chips + audit expand (no generic "verify" scroll)
    thread.addEventListener('click', function (e) {
      var chip = e.target.closest('.cite-chip');
      if (chip) {
        e.preventDefault();
        var turn = chip.closest('.ask-turn');
        var idx = parseInt(chip.getAttribute('data-cite') || '0', 10) - 1;
        var url = chip.getAttribute('data-url');
        if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
          return;
        }
        var item = turn && turn.querySelector('.ask-rail-item[data-cite="' + (idx + 1) + '"]');
        if (item) {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          item.classList.add('ask-rail-item--active');
          setTimeout(function () { item.classList.remove('ask-rail-item--active'); }, 2000);
        }
        return;
      }
      var btn = e.target.closest('.ask-audit-expand');
      if (!btn) return;
      var turn = btn.closest('.ask-turn');
      var panel = turn && turn.querySelector('.ask-audit-panel');
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });

    thread.addEventListener('click', function (e) {
      var stateChip = e.target.closest('[data-ask-state-chip]');
      if (stateChip) {
        e.preventDefault();
        var stateName = stateChip.getAttribute('data-ask-state-name') || stateChip.getAttribute('data-ask-state-chip');
        if (!stateName) return;
        if (!isUnlimited() && cookies.get('opora_demo_ask') >= ASK_FREE_LIMIT) { openGate(); return; }
        runAsk('Write a compliance memo for ' + stateName);
        return;
      }
      var saveBtn = e.target.closest('.ask-save-btn');
      if (saveBtn && !saveBtn.disabled) {
        var turnSave = saveBtn.closest('.ask-turn');
        if (turnSave && turnSave._askState) saveAskToLibrary(saveBtn, turnSave._askState);
        return;
      }
      var copyMdBtn = e.target.closest('.ask-copy-md');
      if (!copyMdBtn) return;
      var turnCopy = copyMdBtn.closest('.ask-turn');
      if (!turnCopy || !turnCopy._askState) return;
      var md = buildSaveContent(
        turnCopy._askState.question,
        turnCopy._askState.answer,
        turnCopy._askState.citations || [],
        turnCopy._askState.meta || {}
      );
      var doneCopy = function () {
        copyMdBtn.textContent = 'Copied';
        setTimeout(function () { copyMdBtn.textContent = 'Copy markdown'; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(md).then(doneCopy).catch(function () {
          try {
            var ta = document.createElement('textarea');
            ta.value = md;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            ta.remove();
            doneCopy();
          } catch (errC) {}
        });
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = clamp(input.value.trim(), 1200);
      if (!q) { input.focus(); return; }

      // gate check
      if (!isUnlimited() && cookies.get('opora_demo_ask') >= ASK_FREE_LIMIT) { openGate(); return; }

      input.value = ''; counter.textContent = '0 / 1200'; autosize();
      runAsk(q);
    });

    /* Homepage / deep-link handoff: /pages/ask-opora?q=… (or sessionStorage) prefill + auto-run */
    try {
      var urlQ = (new URLSearchParams(window.location.search)).get('q');
      var storedQ = '';
      try {
        storedQ = sessionStorage.getItem('opora_ask_prompt') || '';
        if (storedQ) sessionStorage.removeItem('opora_ask_prompt');
      } catch (errS) {}
      var handoffQ = (urlQ && String(urlQ).trim()) || (storedQ && String(storedQ).trim()) || '';
      if (handoffQ) {
        var q0 = clamp(String(handoffQ).trim(), 1200);
        input.value = q0;
        if (counter) counter.textContent = q0.length + ' / 1200';
        autosize();
        if (section && typeof section.scrollIntoView === 'function') {
          try { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { section.scrollIntoView(true); }
        }
        if (!isUnlimited() && cookies.get('opora_demo_ask') >= ASK_FREE_LIMIT) {
          openGate();
        } else {
          input.value = '';
          if (counter) counter.textContent = '0 / 1200';
          autosize();
          runAsk(q0);
        }
        if (window.history && window.history.replaceState) {
          var clean = new URL(window.location.href);
          clean.searchParams.delete('q');
          clean.searchParams.delete('anchor');
          window.history.replaceState({}, '', clean.pathname + clean.search + (clean.hash || '#ask-section'));
        }
      }
    } catch (e) {}

    function needsComplianceStateDisambiguation(question) {
      var q = String(question || '').trim();
      if (!q) return false;
      if (stateCodeFromText(q)) return false;
      var lower = q.toLowerCase();
      if (/\bfor a new state\b/.test(lower)) return true;
      if (/\b(write|draft)\s+(a\s+)?compliance(\s+memo)?\b/.test(lower)) return true;
      if (/\bcompliance memo\b/.test(lower)) return true;
      return false;
    }

    function isClarifyOrRefusalAnswer(answer, meta) {
      if (meta && (meta.clarify || meta.routing === 'clarify_state')) return true;
      return /only provide (compliance )?information specific to|which state do you need|please specify which (state|one)|i can only (help|provide|answer).{0,40}\b(georgia|california|texas)\b/i.test(String(answer || ''));
    }

    function suppressClarifyChrome(turn) {
      if (!turn) return;
      turn.classList.add('is-clarify');
      var rail = turn.querySelector('.ask-rail');
      if (rail) {
        rail.innerHTML = '';
        rail.hidden = true;
      }
      var split = turn.querySelector('.ask-a-split');
      if (split) split.classList.add('ask-a-split--clarify');
      var saveBtn = turn.querySelector('.ask-save-btn');
      if (saveBtn) saveBtn.hidden = true;
      var copyMd = turn.querySelector('.ask-copy-md');
      if (copyMd) copyMd.hidden = true;
      var badge = turn.querySelector('.ask-audit-route');
      if (badge) {
        badge.hidden = true;
        badge.textContent = '';
      }
      var sep = turn.querySelector('.ask-audit-sep');
      if (sep) sep.hidden = true;
      var expand = turn.querySelector('.ask-audit-expand');
      if (expand) expand.hidden = true;
      var panel = turn.querySelector('.ask-audit-panel');
      if (panel) {
        panel.hidden = true;
        panel.innerHTML = '';
      }
      clearAskUtility(turn);
    }

    function renderStateDisambiguation(turn, question) {
      if (!turn) return;
      var body = turn.querySelector('.ask-a-body');
      var states = [
        { code: 'TX', name: 'Texas' },
        { code: 'CA', name: 'California' },
        { code: 'FL', name: 'Florida' },
        { code: 'NY', name: 'New York' },
        { code: 'IL', name: 'Illinois' }
      ];
      var chips = states.map(function (s) {
        return '<button type="button" class="ask-clarify-chip" data-ask-state-chip="' + s.code + '" data-ask-state-name="' + escapeHtml(s.name) + '">' +
          escapeHtml(s.name) + '</button>';
      }).join('');
      if (body) {
        body.innerHTML =
          '<p class="ask-clarify-lead">Which state do you need compliance rules for?</p>' +
          '<p class="ask-clarify-hint">Opora covers all 50 states — pick one to continue (e.g. Texas, California, Florida, New York).</p>' +
          '<div class="ask-clarify-chips" role="group" aria-label="Choose a state">' + chips + '</div>';
      }
      suppressClarifyChrome(turn);
      var auditTs = turn.querySelector('.ask-audit-ts');
      if (auditTs) auditTs.textContent = 'Needs state';
      turn._askState = {
        question: question,
        answer: 'Which state do you need compliance rules for?',
        citations: [],
        meta: { routing: 'clarify_state', clarify: true }
      };
      markActiveAskTurn(turn);
    }

    function runAsk(question) {
      /* Always append a new turn — multi-turn thread within this session. */
      var turn = document.createElement('div');
      turn.className = 'ask-turn thread-turn';
      turn.innerHTML =
          '<div class="ask-q user-query-anchor">' +
            '<span class="ask-q-icon user-badge" aria-hidden="true">YOU</span>' +
            '<p class="ask-q-text user-query-text"></p>' +
          '</div>' +
          '<div class="ask-a turn-response">' +
            '<div class="ask-a-split">' +
              '<div class="ask-a-main">' +
                '<div class="ask-a-body">' +
                  '<span class="ask-thinking" aria-label="Thinking"><span></span><span></span><span></span></span>' +
                  '<span class="ask-thinking-label">Searching cited sources\u2026</span>' +
                '</div>' +
              '</div>' +
              '<aside class="ask-rail citations-sidebar" aria-label="Sources cited"></aside>' +
            '</div>' +
          '</div>' +
          '<div class="ask-audit">' +
            '<span class="ask-audit-left">' +
              '<span class="ask-audit-dot" aria-hidden="true"></span>' +
              '<span class="ask-audit-badge ask-audit-route" hidden></span>' +
              '<span class="ask-audit-sep" aria-hidden="true">\u00b7</span>' +
              '<span class="ask-audit-meta ask-audit-ts">\u2026</span>' +
            '</span>' +
            '<span class="ask-audit-actions">' +
              '<button type="button" class="ask-util-link ask-save-btn" hidden>Save</button>' +
              '<button type="button" class="ask-util-link ask-copy-md" hidden>Copy markdown</button>' +
              '<button type="button" class="ask-util-link ask-audit-expand" aria-expanded="false" hidden>How this was answered</button>' +
            '</span>' +
          '</div>' +
          '<div class="ask-audit-panel" hidden></div>';
      thread.appendChild(turn);
      markActiveAskTurn(turn);
      syncNewThreadUi();

      turn.querySelector('.ask-q-text').textContent = question;
      clearAskUtility(turn);
      turn._askState = null;

      /* Abstract compliance prompts without a state — never hit geo-IP / tenant defaults. */
      if (needsComplianceStateDisambiguation(question)) {
        renderStateDisambiguation(turn, question);
        return;
      }

      var bodyEl = turn.querySelector('.ask-a-body');
      bodyEl.innerHTML =
        '<span class="ask-thinking" aria-label="Thinking"><span></span><span></span><span></span></span>' +
        '<span class="ask-thinking-label">Searching cited sources\u2026</span>';
      turn.querySelector('.ask-rail').innerHTML = '';
      var panel = turn.querySelector('.ask-audit-panel');
      if (panel) { panel.innerHTML = ''; panel.hidden = true; }
      var expand = turn.querySelector('.ask-audit-expand');
      if (expand) { expand.hidden = true; expand.setAttribute('aria-expanded', 'false'); }
      var badge = turn.querySelector('.ask-audit-route');
      if (badge) badge.hidden = true;
      var saveBtn = turn.querySelector('.ask-save-btn');
      if (saveBtn) {
        saveBtn.hidden = true;
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save';
        saveBtn.classList.remove('is-saved');
      }
      var copyMd = turn.querySelector('.ask-copy-md');
      if (copyMd) {
        copyMd.hidden = true;
        copyMd.textContent = 'Copy markdown';
      }
      var auditTs = turn.querySelector('.ask-audit-ts');
      if (auditTs) auditTs.textContent = '\u2026';

      var railEl = turn.querySelector('.ask-rail');
      var t0 = Date.now();

      submit.classList.add('is-loading'); submit.disabled = true;
      try { scrollIfNeeded(); } catch (eScroll) {}

      Promise.resolve().then(function () {
        return streamAsk(question, bodyEl, railEl, auditTs, t0, turn);
      }).then(function () {
        cookies.set('opora_demo_ask', cookies.get('opora_demo_ask') + 1);
        syncRemaining();
        submit.classList.remove('is-loading'); submit.disabled = false;
        syncNewThreadUi();
        try { scrollIfNeeded(); } catch (eScroll2) {}
      }).catch(function (err) {
        submit.classList.remove('is-loading'); submit.disabled = false;
        renderAskError(bodyEl, err);
      });
    }

    function renderAskError(bodyEl, err) {
      var c = errorCopy(err && err.status != null ? err.status : 0, err && err.message);
      bodyEl.innerHTML =
        '<div class="result-error"><span class="err-icon" aria-hidden="true">!</span>' +
        '<div class="err-text"><b>' + escapeHtml(c.title) + '.</b> ' + escapeHtml(c.body) + '</div></div>';
      if (c.gate) setTimeout(openGate, 350);
    }

    /* Stream from /api/ask via OporaAsk client (JSON + SSE + envelope-safe). */
    function streamAsk(question, bodyEl, railEl, auditTs, t0, turn) {
      var askClient = window.OporaAsk;
      if (!askClient || typeof askClient.ask !== 'function') {
        return Promise.reject(new Error('Ask client not loaded'));
      }

      function paint(fullText, citations) {
        /* Never wrap block markdown in <p> — browsers tear the DOM and leave raw [label](url) text. */
        bodyEl.innerHTML = textWithCites(fullText, citations || []) +
          '<span class="stream-caret" aria-hidden="true"></span>';
        updateRail(railEl, citations || [], '');
      }

      var lastText = '';
      return askClient.ask(question, {
        preferJson: true,
        deep: false,
        history: getAskHistoryForRequest(question),
        onChunk: function (text, cites) {
          lastText = text;
          paint(text, cites);
          scrollIfNeeded();
        }
      }).then(function (result) {
        var ans = result.answer || lastText;
        finalize(bodyEl, railEl, auditTs, t0, turn, question, ans, result.citations || [], result.meta || {});
        if (ans && String(ans).trim()) {
          appendAskHistoryPair(question, ans);
          mergeContextFromTurn(question, result.citations || []);
          syncNewThreadUi();
        }
      });
    }

    function buildSaveContent(question, answer, citations, meta) {
      var lines = [answer.trim(), ''];
      if (citations.length) {
        lines.push('## Sources');
        citations.forEach(function (c, i) {
          var name = c.name || c.title || 'Source';
          lines.push('[' + (i + 1) + '] ' + name + (c.url ? ' — ' + c.url : ''));
        });
      }
      if (meta && meta.routing) lines.push('', '_Route: ' + meta.routing + '_');
      if (meta && meta.geo_state) lines.push('_Geo: ' + meta.geo_state + '_');
      return lines.join('\n');
    }

    /* Guest save → stage pending, then same in-place Clerk popup as tools Save. */
    function askGuestSaveThenAuth(payload, btn) {
      var md = payload.content || '';
      var savePayload = {
        title: payload.title,
        body_markdown: md,
        content: md,
        input_payload: payload.input_payload || {},
        metadata: payload.input_payload || {}
      };
      try {
        sessionStorage.setItem('opora_pending_save_d4', JSON.stringify({
          toolSlug: 'ask-opora',
          payload: savePayload
        }));
      } catch (e) {}
      try {
        document.cookie = 'opora_post_save_dest=; path=/; domain=.oporasupply.com; max-age=0; Secure';
      } catch (e0) {}

      function resetBtn() {
        if (!btn) return;
        btn.disabled = false;
        btn.textContent = 'Save';
        btn.classList.remove('is-saved');
      }

      function runAskLibrarySave() {
        try {
          sessionStorage.removeItem('opora_pending_save_d4');
        } catch (e1) {}
        if (!btn) return;
        btn.disabled = true;
        btn.textContent = 'Saving\u2026';
        if (window.OporaWire && typeof window.OporaWire.saveToLibrary === 'function') {
          window.OporaWire.saveToLibrary({
            tool: 'ask_opora',
            title: payload.title,
            body_markdown: md,
            metadata: payload.input_payload || {},
            buttonEl: btn,
            onSaved: function (artifactId) {
              btn.classList.add('is-saved');
              btn.textContent = 'Saved';
              offerAskMemoLink(btn, artifactId);
            }
          });
          return;
        }
        if (window.OporaSave && typeof window.OporaSave.save === 'function') {
          window.OporaSave.save('ask-opora', payload).then(function (res) {
            btn.textContent = 'Saved';
            btn.classList.add('is-saved');
            var id = res && (res.id || res.artifact_id || (res.data && (res.data.id || res.data.artifact_id)));
            offerAskMemoLink(btn, id);
          }).catch(function () {
            resetBtn();
          });
          return;
        }
        resetBtn();
      }

      function openSavePopup() {
        if (window.OporaActionBar && typeof window.OporaActionBar.openGuestSaveInPlace === 'function') {
          window.OporaActionBar.openGuestSaveInPlace('ask-opora', savePayload, {
            returnToTool: true,
            title: 'Save this result',
            tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
            onAuthed: runAskLibrarySave
          });
          resetBtn();
          return true;
        }
        if (openAuthModal('sign-up', {
          title: 'Save this result',
          tagline: 'Create a free account to edit, duplicate, and access this result across devices.',
          onAuthed: runAskLibrarySave
        })) {
          resetBtn();
          return true;
        }
        return false;
      }

      /* Stage server-side pending token in background (dashboard claim fallback). */
      try {
        var api = ((window.OporaEdge && window.OporaEdge.WORKER_URL) || window.OPORA_WORKER_URL || 'https://api.oporasupply.com').replace(/\/$/, '');
        fetch(api + '/api/artifacts/pending', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            tool: 'ask_opora',
            tool_slug: 'ask_opora',
            title: payload.title,
            body_markdown: md,
            content: md,
            input_payload: payload.input_payload || {},
            metadata: payload.input_payload || {}
          })
        }).then(function (r) { return r.json(); }).then(function (j) {
          var token = j && (j.token || (j.data && j.data.token));
          if (token) {
            document.cookie = 'opora_pending_token=' + encodeURIComponent(token) +
              '; path=/; domain=.oporasupply.com; max-age=3600; SameSite=Lax; Secure';
          }
        }).catch(function () {});
      } catch (e2) {}

      if (openSavePopup()) return;

      /* Last resort only if auth modal missing — keep user informed. */
      resetBtn();
      try {
        if (window.OporaEdge && typeof window.OporaEdge.stashAuthReturn === 'function') window.OporaEdge.stashAuthReturn();
      } catch (e3) {}
      var url = (window.OporaEdge && typeof window.OporaEdge.dashboardAuthUrl === 'function')
        ? window.OporaEdge.dashboardAuthUrl('sign-up')
        : 'https://dashboard.oporasupply.com/';
      window.location.href = url;
    }

    /* After save: permanent share memo URL (existing /api/artifacts/:id/share). Not session history. */
    function offerAskMemoLink(saveBtn, artifactId) {
      if (!saveBtn || !artifactId) return;
      var actions = saveBtn.parentNode;
      if (!actions) return;
      if (actions.querySelector('.ask-memo-link-btn')) return;
      var linkBtn = document.createElement('button');
      linkBtn.type = 'button';
      linkBtn.className = 'ask-memo-link-btn';
      linkBtn.textContent = 'Copy memo link';
      linkBtn.addEventListener('click', function () {
        if (window.OporaWire && typeof window.OporaWire.copyShareLink === 'function') {
          window.OporaWire.copyShareLink({
            artifactId: artifactId,
            expiry: 'never',
            buttonEl: linkBtn,
            buttonLabel: 'Copy memo link'
          });
          return;
        }
        window.open('/pages/account/library', '_blank', 'noopener');
      });
      actions.insertBefore(linkBtn, saveBtn.nextSibling);
      if (!actions.querySelector('.ask-memo-library-link')) {
        var lib = document.createElement('a');
        lib.className = 'ask-memo-library-link';
        lib.href = 'https://dashboard.oporasupply.com/?view=workspace&ws=library';
        lib.target = '_blank';
        lib.rel = 'noopener noreferrer';
        lib.textContent = 'Open library';
        actions.appendChild(lib);
      }
    }

    function saveAskToLibrary(btn, state) {
      var payload = {
        title: state.question.length > 120 ? state.question.slice(0, 117) + '...' : state.question,
        content: buildSaveContent(state.question, state.answer, state.citations, state.meta),
        input_payload: {
          question: state.question,
          citations: state.citations,
          routing: state.meta && state.meta.routing,
          geo_state: state.meta && state.meta.geo_state
        }
      };

      var signedIn = !!(window.Clerk && (window.Clerk.session || window.Clerk.user));
      if (!signedIn) {
        btn.disabled = true;
        btn.textContent = 'Sign in\u2026';
        askGuestSaveThenAuth(payload, btn);
        return;
      }

      if (window.OporaWire && typeof window.OporaWire.saveToLibrary === 'function') {
        window.OporaWire.saveToLibrary({
          tool: 'ask_opora',
          title: payload.title,
          body_markdown: payload.content,
          metadata: payload.input_payload,
          buttonEl: btn,
          onSaved: function (artifactId) {
            btn.classList.add('is-saved');
            btn.textContent = 'Saved';
            offerAskMemoLink(btn, artifactId);
          }
        });
        return;
      }

      if (window.OporaSave && typeof window.OporaSave.save === 'function') {
        btn.disabled = true;
        btn.textContent = 'Saving\u2026';
        window.OporaSave.save('ask-opora', payload).then(function (res) {
          btn.textContent = 'Saved';
          btn.classList.add('is-saved');
          var id = res && (res.id || res.artifact_id || (res.data && (res.data.id || res.data.artifact_id)));
          offerAskMemoLink(btn, id);
        }).catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Save';
          if (err && err.status === 401) {
            askGuestSaveThenAuth(payload, btn);
          }
        });
        return;
      }

      askGuestSaveThenAuth(payload, btn);
    }

    function sourceTypeLabel(t) {
      var s = String(t || '').toLowerCase();
      if (s === 'field_guide') return 'Field Guide';
      if (s === 'federal_data') return 'BLS';
      if (s === 'state_regulation') return 'State';
      if (s === 'federal_guidance') return 'Federal';
      return 'Source';
    }

    function explainRouting(routing) {
      var r = String(routing || '');
      if (r.indexOf('geo_curated') === 0) {
        return { badge: 'Geo-verified', detail: 'Curated state/metro wage and compliance facts — not generic web search.' };
      }
      if (r.indexOf('rag') >= 0) {
        return { badge: 'RAG + corpus', detail: 'Retrieved from 3,500+ indexed Field Guide and operator chunks, then cited synthesis.' };
      }
      return { badge: 'Corpus', detail: 'Assembled from Opora operator corpus and public references.' };
    }

    function formatVerifiedSourcesGeoLabel(meta, question) {
      var codes = [];
      if (meta && Array.isArray(meta.detected_states)) {
        meta.detected_states.forEach(function (c) {
          var code = String(c || '').toUpperCase().slice(0, 2);
          if (/^[A-Z]{2}$/.test(code) && codes.indexOf(code) < 0) codes.push(code);
        });
      }
      /* Prefer question tokens over stale geo_state when they conflict */
      if (window.OporaGeo && OporaGeo.extract) {
        try {
          var gq = OporaGeo.extract(question || '');
          if (gq && gq.state_code) {
            var qc = String(gq.state_code).toUpperCase();
            if (/^[A-Z]{2}$/.test(qc) && codes.indexOf(qc) < 0) {
              /* only add if empty — never prepend stale extras */
              if (!codes.length) codes.push(qc);
            }
          }
        } catch (eG) {}
      }
      if (!codes.length && meta && meta.geo_state) {
        var gs = String(meta.geo_state).trim().toUpperCase();
        var m = gs.match(/\b([A-Z]{2})\b/);
        if (m) codes.push(m[1]);
        else if (/^[A-Z]{2}$/.test(gs)) codes.push(gs);
      }
      return codes.join(', ');
    }

    function markActiveAskTurn(activeTurn) {
      if (!thread) return;
      Array.prototype.forEach.call(thread.querySelectorAll('.ask-turn'), function (t) {
        t.classList.toggle('is-active-turn', t === activeTurn);
      });
      demoteHistoricalAskCtas();
    }

    function demoteHistoricalAskCtas() {
      if (!thread) return;
      var turns = thread.querySelectorAll('.ask-turn');
      Array.prototype.forEach.call(turns, function (t, idx) {
        var isLast = idx === turns.length - 1;
        t.classList.toggle('is-active-turn', isLast);
        Array.prototype.forEach.call(t.querySelectorAll(
          'a.ask-handoff-primary, button.ask-handoff-primary, a.ask-handoff-primary--audit, a.ask-handoff-secondary, button.ask-handoff-secondary, a.ask-handoff-secondary--audit'
        ), function (el) {
          var isPrimary = el.classList.contains('ask-handoff-primary') || el.classList.contains('ask-handoff-primary--audit');
          if (isLast) {
            styleAuditCta(el, isPrimary ? 'primary' : 'secondary');
          } else {
            el.setAttribute('style',
              'display:inline-flex!important;align-items:center;justify-content:center;' +
              'min-height:32px;padding:6px 12px;border-radius:999px;border:1px solid #C5CDD6;' +
              'background:#fff!important;color:#8B93A0!important;font:600 12px/1.3 Inter,Barlow,sans-serif;' +
              'text-decoration:none!important;white-space:nowrap;cursor:pointer;opacity:1!important;' +
              'visibility:visible!important;letter-spacing:0!important;text-transform:none!important;'
            );
          }
        });
      });
    }

    function updateRail(railEl, citations, geoLabel) {
      if (!railEl) return;
      if (!citations.length) {
        railEl.innerHTML = '';
        return;
      }
      var geoNote = geoLabel ? ' \u00b7 ' + escapeHtml(geoLabel) : '';
      railEl.innerHTML =
        '<div class="ask-rail-label">Citations' + geoNote + '</div>' +
        '<div class="ask-rail-list ask-rail-list--pills" role="list">' + citations.map(function(c, i) {
          var name = c.name || c.title || c.source || 'Source';
          var short = name.length > 42 ? name.slice(0, 39) + '\u2026' : name;
          var url = c.url || '';
          var type = sourceTypeLabel(c.source_type);
          var label = '[' + (i + 1) + '] ' + (type && type !== 'Source' ? type + ' \u00b7 ' : '') + short;
          var attrs = ' class="ask-rail-item citation-pill" role="listitem" data-cite="' + (i + 1) + '"';
          if (url) {
            return '<a' + attrs + ' href="' + escapeHtml(url) + '" target="_blank" rel="noopener noreferrer" title="' + escapeHtml(name) + '">' +
              escapeHtml(label) + ' <span class="ask-rail-open" aria-hidden="true">\u2197</span></a>';
          }
          return '<div' + attrs + ' title="' + escapeHtml(name) + '">' + escapeHtml(label) + '</div>';
        }).join('') + '</div>';
    }

    function buildAuditPanel(meta, question, citations, elapsed) {
      var geo = formatVerifiedSourcesGeoLabel(meta, question);
      var exp = explainRouting(meta && meta.routing);
      var rows = [
        '<p class="ask-audit-panel-lead"><strong>' + escapeHtml(exp.badge) + '</strong> — ' + escapeHtml(exp.detail) + '</p>'
      ];
      if (geo) {
        var geoScope = (meta && meta.is_comparative) || (geo.indexOf(',') >= 0)
          ? 'answer covers these jurisdictions.'
          : 'answer scoped to this jurisdiction.';
        rows.push('<p class="ask-audit-panel-row"><span class="ask-audit-panel-k">Geo lock</span> ' + escapeHtml(geo) + ' — ' + geoScope + '</p>');
      }
      if (meta && meta.routing) {
        rows.push('<p class="ask-audit-panel-row"><span class="ask-audit-panel-k">Route</span> <code>' + escapeHtml(meta.routing) + '</code></p>');
      }
      rows.push('<p class="ask-audit-panel-row"><span class="ask-audit-panel-k">Time</span> ' + escapeHtml(elapsed) + '</p>');
      if (citations.length) {
        rows.push('<ul class="ask-audit-panel-sources">' + citations.map(function(c, i) {
          var name = escapeHtml(c.name || c.title || 'Source');
          var url = c.url || '';
          if (url) {
            return '<li><a href="' + escapeHtml(url) + '" target="_blank" rel="noopener">[' + (i+1) + '] ' + name + '</a></li>';
          }
          return '<li>[' + (i+1) + '] ' + name + '</li>';
        }).join('') + '</ul>');
      }
      rows.push('<p class="ask-audit-panel-note">Numbers in the answer link to sources. Verify wage schedules on SAM.gov and state labor sites before bidding.</p>');
      return rows.join('');
    }


    var ASK_STATE_SLUGS = {
      AL: 'alabama', AK: 'alaska', AZ: 'arizona', AR: 'arkansas', CA: 'california',
      CO: 'colorado', CT: 'connecticut', DE: 'delaware', FL: 'florida', GA: 'georgia',
      HI: 'hawaii', ID: 'idaho', IL: 'illinois', IN: 'indiana', IA: 'iowa',
      KS: 'kansas', KY: 'kentucky', LA: 'louisiana', ME: 'maine', MD: 'maryland',
      MA: 'massachusetts', MI: 'michigan', MN: 'minnesota', MS: 'mississippi', MO: 'missouri',
      MT: 'montana', NE: 'nebraska', NV: 'nevada', NH: 'new-hampshire', NJ: 'new-jersey',
      NM: 'new-mexico', NY: 'new-york', NC: 'north-carolina', ND: 'north-dakota', OH: 'ohio',
      OK: 'oklahoma', OR: 'oregon', PA: 'pennsylvania', RI: 'rhode-island', SC: 'south-carolina',
      SD: 'south-dakota', TN: 'tennessee', TX: 'texas', UT: 'utah', VT: 'vermont',
      VA: 'virginia', WA: 'washington', WV: 'west-virginia', WI: 'wisconsin', WY: 'wyoming',
      DC: 'district-of-columbia'
    };
    var ASK_STATE_NAMES = {
      alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA',
      colorado: 'CO', connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA',
      hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA',
      kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD',
      massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS', missouri: 'MO',
      montana: 'MT', nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
      'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH',
      oklahoma: 'OK', oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
      'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT',
      virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY'
    };


    function extractWageRate(text) {
      var s = String(text || '');
      /* Prefer explicit BLS / median anchors over statutory floors */
      var median = s.match(/(?:bls\s+)?(?:state|metro|national|tx|texas)?\s*median(?:\s+\(primary\))?(?:\s+hourly)?(?:\s+wage)?[^\$\d]{0,48}\$\s*([\d,]+(?:\.\d{1,2})?)/i)
        || s.match(/\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour)[^.\n]{0,48}\bmedian\b/i)
        || s.match(/market\s+median[^\$\d]{0,40}\$\s*([\d,]+(?:\.\d{1,2})?)/i);
      if (median) return median[1].replace(/,/g, '');
      var preferred = s.match(/(?:pay(?:ing)?(?:\s+\w+){0,4}\s+)\$?\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour|an\s*hour|\/hour)?\b/i);
      if (preferred) return preferred[1].replace(/,/g, '');
      preferred = s.match(/(?:base\s+wage|paying(?:\s+a)?|wage\s+of|hourly\s+wage)\s*(?:of\s*)?\$?\s*([\d,]+(?:\.\d{1,2})?)/i);
      if (preferred) return preferred[1].replace(/,/g, '');
      preferred = s.match(/\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour)[^.\n]{0,48}base\s+wage/i);
      if (preferred) return preferred[1].replace(/,/g, '');
      preferred = s.match(/base(?:\s+direct)?\s+wage[^\$\d]{0,24}\$\s*([\d,]+(?:\.\d{1,2})?)/i);
      if (preferred) return preferred[1].replace(/,/g, '');
      var m = s.match(/\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour|\/hour|an\s*hour)/i);
      if (m) {
        var ctx = s.slice(Math.max(0, m.index - 48), m.index + m[0].length + 48);
        if (/\b(bill\s+rate|target\s+rate|charge|approximately|burdened|loaded\s+(?:labor|cost)|contract\s+price|minimum\s+wage|statutory\s+floor|federal\s+floor)\b/i.test(ctx)) {
          /* skip non-base / floor mentions */
        } else {
          return m[1].replace(/,/g, '');
        }
      }
      m = s.match(/(?:median|mean|average|hourly|wage|pay)\s*(?:wage|rate|pay)?[^\$\d]{0,24}\$\s*([\d,]+(?:\.\d{1,2})?)/i);
      if (m) {
        var ctx2 = s.slice(Math.max(0, m.index - 40), m.index + m[0].length + 40);
        if (/\b(minimum\s+wage|statutory\s+floor|federal\s+floor)\b/i.test(ctx2)) return null;
        return m[1].replace(/,/g, '');
      }
      return null;
    }

    function isMarketSalaryAsk(question) {
      var q = String(question || '').toLowerCase();
      if (/\b(minimum\s+wage|wage\s+floor|statutory\s+floor|legal\s+wage\s+floor)\b/.test(q) &&
          !/\b(median|salary|earn|bls|how much)\b/.test(q)) {
        return false;
      }
      return /\b(salary|salaries|earn|median|bls|oews|how much|pay|wage|wages)\b/.test(q);
    }

    /** Prefer the user's stated wage in the question over statutory floors in the answer. */
    function extractStatedWagePreferQuestion(question, answer) {
      var fromQ = extractWageRate(question);
      if (fromQ) {
        var nq = parseFloat(fromQ, 10);
        if (nq > 0 && nq < 200) return String(nq);
      }
      var fromA = extractWageRate(answer);
      if (fromA) {
        var na = parseFloat(fromA, 10);
        /* Never scaffold commercial salary asks off the federal/state floor alone */
        if (isMarketSalaryAsk(question) && na > 0 && na <= 8.5) {
          var medianRetry = String(answer || '').match(
            /(?:bls|state|metro|market)?\s*median[^\$\d]{0,48}\$\s*([\d,]+(?:\.\d{1,2})?)/i
          );
          if (medianRetry) {
            var nm = parseFloat(medianRetry[1].replace(/,/g, ''), 10);
            if (nm > 8.5 && nm < 200) return String(nm);
          }
          return null;
        }
        if (na > 0 && na < 200) return String(na);
      }
      return null;
    }

    function wageScaffoldFootnote(question, answer, stateCode, medianWage) {
      var st = String(stateCode || '').toUpperCase();
      var med = parseFloat(medianWage, 10);
      if (st === 'TX' && med > 8.5) {
        return 'Texas minimum wage matches the federal floor of $7.25/hr (TX Labor Code § 62.051), but market median for commercial cleaners is ' +
          formatAskMoney(med) + '/hr. Workers\' compensation is elective for private employers in Texas (TX Labor Code § 406.002), though non-subscribers forfeit common-law defenses against employee negligence claims.';
      }
      if (isMarketSalaryAsk(question) && med > 8.5) {
        return 'Statutory minimum wage is a legal floor only — the financial stack above uses the BLS OEWS market median (' + formatAskMoney(med) + '/hr), not the floor.';
      }
      return null;
    }

    function isOffTheBooksAsk(question) {
      return /\b(?:under\s+the\s+table|off[- ]the[- ]books|cash\s+(?:only|pay)|unreported\s+(?:wages?|pay))\b/i.test(
        String(question || '')
      );
    }

    function buildWageBurdenSpec(baseWage, opts) {
      opts = opts || {};
      var base = parseFloat(baseWage, 10);
      if (!(base > 0)) return null;
      var burdenPct = opts.burdenPct != null ? opts.burdenPct : 22;
      var margin = opts.margin != null ? opts.margin : 25;
      var loaded = Math.round(base * (1 + burdenPct / 100) * 100) / 100;
      var bill = Math.round((loaded / (1 - margin / 100)) * 100) / 100;
      var naiveMarkup = Math.round(loaded * (1 + margin / 100) * 100) / 100;
      var underbill = Math.round((bill - naiveMarkup) * 100) / 100;
      return {
        base: base,
        loaded: loaded,
        bill: bill,
        margin: margin,
        burdenPct: burdenPct,
        burdenAmt: Math.round((loaded - base) * 100) / 100,
        naiveMarkup: naiveMarkup,
        underbill: underbill,
        contradiction: null
      };
    }

    /**
     * Off-the-books / under-table: NEVER skip scaffolding.
     * Show legal W-2 burden stack off the stated rate + PROHIBITED flag.
     */
    function buildOffBooksComplianceRows(baseWage, stateCode) {
      var base = parseFloat(baseWage, 10);
      if (!(base > 0)) base = 14;
      var burdenPct = 22.4;
      var margin = 25;
      var burdenAmt = Math.round(base * (burdenPct / 100) * 100) / 100;
      var loaded = Math.round((base + burdenAmt) * 100) / 100;
      var bill = Math.round((loaded / (1 - margin / 100)) * 100) / 100;
      var wcNote = stateCode === 'PA'
        ? 'FICA (7.65%), FUTA/PA SUTA, PA WC Code 923, OSHA Bio-PPE'
        : burdenBreakdownLabel(stateCode, burdenPct);
      return [
        {
          component: 'Proposed Base Wage',
          detail: 'Stated input wage (still subject to W-2 withholding)',
          rate: formatAskMoney(base) + '/hr'
        },
        {
          component: 'Statutory Burden (~' + burdenPct + '%)',
          detail: wcNote,
          rate: '+' + formatAskMoney(burdenAmt) + '/hr'
        },
        {
          component: 'Fully Burdened Legal Cost',
          detail: 'Direct labor break-even baseline',
          rate: formatAskMoney(loaded) + '/hr'
        },
        {
          component: 'Defensible Bill Rate (25% Divisor)',
          detail: formatAskMoney(loaded) + ' / (1 \u2212 0.25) \u2014 compliant gross margin',
          rate: formatAskMoney(bill) + '/hr',
          highlight: true
        },
        {
          component: 'Compliance Non-Negotiable',
          detail: 'Paying off-the-books voids WC, triggers IRS \u00a7 6656 / FLSA exposure',
          rate: 'UNLAWFUL',
          warning: true
        }
      ];
    }

    var OFF_BOOKS_SCAFFOLD_FOOTNOTE =
      'Federal & state law mandate W-2 withholding for direct labor. Unburdened cash labor cannot be legally defended.';

    function extractMoneyNear(text, patterns) {
      var s = String(text || '');
      for (var i = 0; i < patterns.length; i++) {
        var m = s.match(patterns[i]);
        if (m) return String(m[1]).replace(/,/g, '');
      }
      return null;
    }

    function extractMarginPct(text) {
      var s = String(text || '');
      var m = s.match(/(\d+(?:\.\d+)?)\s*%\s*(?:gross\s*)?margin/i);
      if (m) return parseFloat(m[1], 10);
      m = s.match(/(?:gross\s*)?margin[^.\n%\d]{0,40}(\d+(?:\.\d+)?)\s*%/i);
      return m ? parseFloat(m[1], 10) : null;
    }

    function extractBurdenPct(text) {
      var s = String(text || '');
      var m = s.match(/(\d+(?:\.\d+)?)\s*%\s*(?:labor\s+|payroll\s+|employer\s+|statutory\s+)?burden/i);
      if (m) return parseFloat(m[1], 10);
      m = s.match(/(?:labor\s+|payroll\s+|employer\s+|statutory\s+)?burden(?:\s+rate)?[^%\d]{0,40}(\d+(?:\.\d+)?)\s*%/i);
      if (m) return parseFloat(m[1], 10);
      m = s.match(/adds?\s+a?\s*(\d+(?:\.\d+)?)\s*%\s*burden/i);
      return m ? parseFloat(m[1], 10) : null;
    }

    function extractBillRateAmount(text) {
      return extractMoneyNear(text, [
        /(?:fully\s+loaded\s+)?bill\s+rate[^\$\d]{0,48}\$\s*([\d,]+(?:\.\d{1,2})?)/i,
        /(?:charge|target)\s+(?:about\s+)?\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour)/i,
        /\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr|per\s*hour)[^.\n]{0,40}(?:bill\s+rate|margin)/i
      ]);
    }

    function extractLoadedAmount(text) {
      return extractMoneyNear(text, [
        /(?:fully\s+)?(?:burdened|loaded)\s+(?:labor\s+)?(?:rate|cost|wage)[^\$\d]{0,40}\$\s*([\d,]+(?:\.\d{1,2})?)/i,
        /(?:fully\s+)?loaded\s+(?:labor|rate|cost|wage)[^\$\d]{0,40}\$\s*([\d,]+(?:\.\d{1,2})?)/i,
        /loaded\s+(?:rate\s+)?is\s+approximately\s+\$\s*([\d,]+(?:\.\d{1,2})?)/i,
        /\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:\/\s*hr)?[^.\n]{0,24}(?:fully\s+)?(?:burdened|loaded)/i,
        /(?:direct\s+labor\s+)?break-?even(?:\s+cost)?[^\$\d]{0,40}\$\s*([\d,]+(?:\.\d{1,2})?)/i
      ]);
    }

    function engineRowsFromMeta(meta) {
      var er = meta && meta.engine_result;
      if (!er || !Array.isArray(er.scaffoldingRows) || !er.scaffoldingRows.length) return null;
      return er.scaffoldingRows.map(function (r) {
        return {
          component: r.metric || r.component || '',
          detail: r.breakdown || r.detail || '',
          rate: r.value || r.rate || '',
          warning: !!(r.isWarning || r.warning),
          highlight: !!(r.isHighlight || r.highlight)
        };
      });
    }

    function engineFootnoteFromMeta(meta) {
      var er = meta && meta.engine_result;
      return (er && er.tableFooterNote) ? String(er.tableFooterNote) : null;
    }

    function shouldMountEngineScaffold(meta) {
      return !!(meta && meta.engine_result && meta.engine_result.mountScaffold &&
        Array.isArray(meta.engine_result.scaffoldingRows) && meta.engine_result.scaffoldingRows.length);
    }

    function mountAskMathChips(turn, meta) {
      if (!turn) return;
      var er = meta && meta.engine_result;
      var chips = er && Array.isArray(er.mathChips) ? er.mathChips : [];
      if (!chips.length) return;
      var body = turn.querySelector('.ask-a-body');
      if (!body) return;
      var existing = body.querySelector('.ask-math-chips');
      if (existing) existing.remove();
      var wrap = document.createElement('div');
      wrap.className = 'ask-math-chips';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Open related tools');
      chips.slice(0, 6).forEach(function (chip) {
        if (!chip || !chip.label) return;
        var a = document.createElement('a');
        a.className = 'ask-math-chip';
        a.href = withPreviewParam(String(chip.href || '/pages/tools'));
        a.title = chip.tip || chip.label;
        a.innerHTML = '<span class="ask-math-chip__gear" aria-hidden="true">\u2699</span><span></span>';
        a.querySelector('span:last-child').textContent = chip.label;
        var tool = chip.tool || 'page';
        wireToolHandoff(a, tool === 'production-rate' ? 'page' : tool, {
          source_tool: 'ask-opora',
          math_chip: chip.label
        });
        wrap.appendChild(a);
      });
      if (!wrap.childNodes.length) return;
      var firstP = body.querySelector('p');
      if (firstP && firstP.parentNode === body) {
        if (firstP.nextSibling) body.insertBefore(wrap, firstP.nextSibling);
        else body.appendChild(wrap);
      } else {
        body.insertBefore(wrap, body.firstChild);
      }
    }

    function mountEngineCtas(turn, meta, stateCode) {
      if (!turn || !meta) return false;
      var er = meta.engine_result;
      var primary = (er && er.primaryCta) || (meta.ctas && meta.ctas[0]);
      if (!primary || !primary.href) return false;
      /* Intent-driven: exactly one primary CTA. */
      var html =
        '<a class="ask-handoff-primary" href="' + escapeHtml(withPreviewParam(primary.href)) + '">' +
          escapeHtml(primary.label || 'Continue →') + '</a>';
      var row = insertAskHandoffRow(turn, html);
      var pTool = (primary.tool) || 'page';
      wireToolHandoff(row.querySelector('.ask-handoff-primary'), pTool, {
        source_tool: 'ask-opora',
        state: stateCode || undefined,
        pipeline_intent: (er && er.intent) || meta.pipeline_intent || undefined
      });
      hideAskExternalHandoff();
      return true;
    }

    function isOwnerEconomicsAsk(question, answer, meta) {
      if (meta && meta.intent === 'OWNER_REVENUE_ECONOMICS') return true;
      if (meta && meta.routing && /solo_operator_economics/i.test(String(meta.routing))) return true;
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      if (/solo operator annual economics|owner-operator gross|net owner take-home|owner-operator discretionary/.test(c)) return true;
      var owner = /\b(single operator|solo operator|owner-?operator|1-?person|one-person|solo gig|cleaning gig|owner|my business|cleaning business|revenue|profit|take-home|pocket|gross receipts|annually|every year)\b/.test(c);
      var business = /\b(business|operator|owner|solo|company|gig)\b/.test(c);
      var money = /\b(revenue|profit|annual|annually|every year|take-home|pocket|cash|gross receipts|how much money|make money|after expenses)\b/.test(c);
      return owner && business && money;
    }

    function isPayrollDeductionAsk(question, meta) {
      if (meta && meta.intent === 'PAYROLL_DEDUCTION_COMPLIANCE') return true;
      if (meta && meta.routing && /payroll_deduction_compliance/i.test(String(meta.routing))) return true;
      var q = String(question || '');
      var moneyAction = /\b(?:deduct|deduction|take\s+(?:out|\$)|withhold|payroll\s+deduction|first\s+check|paycheck)\b/i.test(q);
      var gear = /\b(?:uniform|boots?|shoe|ppe|gear|vest|slip[- ]resistant|high[- ]vis(?:ibility)?)\b/i.test(q);
      return moneyAction && gear;
    }

    var DEDUCTION_SCAFFOLD_FOOTNOTE =
      'Washington State Department of Labor & Industries mandates that required safety gear and uniforms bearing company insignia must be furnished entirely at employer expense. Never condition PPE deductions on remaining above minimum wage.';

    function extractDeductionAmount(question) {
      var q = String(question || '');
      var m = q.match(/\$\s*(\d+(?:\.\d{1,2})?)/) || q.match(/\b(\d+(?:\.\d{1,2})?)\s*(?:dollars?|bucks)\b/i);
      if (!m) return 50;
      var n = parseFloat(m[1], 10);
      return (n > 0 && n < 5000) ? n : 50;
    }

    function buildPayrollDeductionScaffoldingRows(question) {
      var amount = extractDeductionAmount(question);
      var money = formatAskMoney(amount);
      return [
        {
          component: 'Stated First Check Deduction',
          detail: 'Slip-resistant boots / uniform / required PPE cost-shift',
          rate: '\u2212' + money
        },
        {
          component: 'Washington L&I Legality',
          detail: 'WAC 296-800-160 (PPE at no cost) & WAC 296-126-028 (unlawful deductions)',
          rate: 'PROHIBITED',
          warning: true
        },
        {
          component: 'Employer Cost Absorption',
          detail: 'Mandatory employer-provided PPE / uniform allowance (overhead expense)',
          rate: '+' + money
        },
        {
          component: 'Seattle Minimum Wage Floor',
          detail: 'SMC 14.19 (schedule varies by employer size \u2014 verify current)',
          rate: '$19.97\u2013$20.76/hr'
        },
        {
          component: 'Effective Net Wage Impact',
          detail: 'Deducting ' + money + ' from onboarding pay \u2192 SMC 14.20 / RCW 49.52.050 wage-theft exposure',
          rate: 'DOUBLE DAMAGES',
          warning: true
        }
      ];
    }

    /** Same Financial Scaffolding shell — solo capacity schema (not W-2 payroll). */
    function buildSoloOverheadDetails(detectedStates) {
      var codes = (detectedStates || []).map(function (c) { return String(c || '').toUpperCase(); });
      var lineItems = ['General liability insurance'];
      if (codes.indexOf('CA') >= 0) lineItems.push('CA DIR janitorial registration ($500)');
      if (codes.indexOf('WA') >= 0) lineItems.push('WA L&I industrial insurance (Risk Class 6602-03)');
      if (codes.indexOf('NY') >= 0) lineItems.push('NYC transit/parking & commercial GL limits');
      if (codes.indexOf('NV') >= 0) lineItems.push('NV local business license / privilege tax where applicable');
      lineItems.push('fuel & vehicle maintenance', 'cleaning chemicals & supplies', 'marketing');
      return {
        breakdown: lineItems.join(', '),
        costEstimate: '-$27,500/yr'
      };
    }

    function buildSoloOperatorScaffoldingRows(detectedStates) {
      var overhead = buildSoloOverheadDetails(detectedStates);
      return [
        {
          component: 'Annual Billable Capacity',
          detail: '40 production hrs/wk \u00d7 50 operational weeks',
          rate: '2,000 hrs/yr'
        },
        {
          component: 'Weighted Billable Rate (Blended)',
          detail: 'Mid-tier market billable baseline ($55.00/hr)',
          rate: '$55.00/hr'
        },
        {
          component: 'Gross Revenue Ceiling',
          detail: '2,000 hrs \u00d7 $55.00/hr',
          rate: '$110,000/yr'
        },
        {
          component: 'Estimated Overhead Drag (~25%)',
          detail: overhead.breakdown,
          rate: overhead.costEstimate,
          warning: true
        },
        {
          component: 'Net Owner Take-Home (Pre-Tax)',
          detail: 'Gross revenue minus lean operating overhead (~65\u201375% retention)',
          rate: '$82,500/yr',
          highlight: true
        }
      ];
    }

    var SOLO_SCAFFOLD_FOOTNOTE =
      'Target Net = Gross Revenue \u00d7 (1 \u2212 Overhead Drag). Solo models do not apply W-2 statutory payroll burden.';

    function isSqftBenchmarkAsk(question) {
      var q = String(question || '').toLowerCase();
      if (!q.trim()) return false;
      if (/(draft|write|generate|assemble)\s+(a\s+)?(bid|packet|sow|proposal|contract)/i.test(q)) return false;
      if (/(\/sqft|per\s*sq\.?\s*ft|per\s*sqft|per\s*square\s*foot|\$\s*\/\s*sq)/i.test(q)) return true;
      if (/\b(sqft|sq\.?\s*ft|square\s*feet|square\s*foot|rsf)\b/.test(q) &&
          /\b(benchmark|rate|price|pricing|cost|bid|quote|facility|class\s*[abc]|janitorial|cleaning)\b/.test(q)) {
        return true;
      }
      return /\b(facility\s+benchmark|issa\s*6[0-9]{2}|issa\s*447)\b/.test(q);
    }

    function classifyClientAskIntent(question) {
      var q = String(question || '').toLowerCase();
      if (/(draft|write|generate|assemble)\s+(a\s+)?(bid|packet|sow|proposal|contract|scope)/i.test(q)) {
        return 'DRAFTING_REQUEST';
      }
      if (isSqftBenchmarkAsk(q)) return 'SQFT_BENCHMARK';
      if (/\b(statutory burden|burden rate|fica|suta|futa|workers?\s*comp(?:ensation)?\s+rate)\b/i.test(q)) {
        return 'STATUTORY_BURDEN';
      }
      if (/\b(wage|wages|salary|hourly rate|pay scale|prevailing wage|bls|oews|median|compensation)\b/i.test(q)) {
        return 'WAGE_RATE';
      }
      return 'COMPLIANCE_SPEC';
    }

    function alignClientCitations(answer, citations) {
      var original = Array.isArray(citations) ? citations.slice() : [];
      var text = String(answer || '');
      if (!original.length) {
        return { answer: text.replace(/\[(\d{1,2})\]/g, ''), citations: [] };
      }
      var re = /\[(\d{1,2})\]/g;
      var seen = {};
      var m;
      while ((m = re.exec(text))) seen[parseInt(m[1], 10)] = true;
      var keys = Object.keys(seen).map(function (k) { return parseInt(k, 10); }).sort(function (a, b) { return a - b; });
      var display = [];
      var remap = {};
      keys.forEach(function (oldIdx) {
        var c = original[oldIdx - 1];
        if (!c) return;
        remap[oldIdx] = display.length + 1;
        display.push(c);
      });
      if (!keys.length) {
        display = original.slice(0, 6);
      } else {
        text = text.replace(/\[(\d{1,2})\]/g, function (full, n) {
          var mapped = remap[parseInt(n, 10)];
          return mapped ? '[' + mapped + ']' : '';
        });
      }
      var maxIdx = display.length;
      text = text.replace(/\[(\d{1,2})\]/g, function (full, n) {
        var idx = parseInt(n, 10);
        return idx >= 1 && idx <= maxIdx ? full : '';
      });
      return { answer: text, citations: display };
    }

    function isWageAsk(question, answer, meta) {
      if (isOwnerEconomicsAsk(question, answer, meta)) return false;
      if (isSqftBenchmarkAsk(question) || (meta && meta.intent === 'SQFT_BENCHMARK')) return false;
      if (meta && (meta.intent === 'SQFT_BENCHMARK' || meta.pipeline_intent === 'SQFT_BENCHMARK')) return false;
      if (meta && meta.intent === 'EMPLOYEE_WAGE_BURDEN') return true;
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      if (isOffTheBooksAsk(question) && /\$?\s*\d/.test(String(question || ''))) return true;
      /* Require wage language — "janitorial" alone (sqft benchmarks) is not a wage ask */
      return /\b(wage|wages|hourly rate|pay rate|prevailing|bls|oews|compensation|pay my guy|under the table|median)\b/.test(c) &&
        /\b(janitor|janitorial|cleaner|custodian|wage|pay|hourly)\b/.test(c);
    }

    function isBillRateAsk(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      return /\b(bill rate|billing rate|loaded billing|fully loaded|target margin|gross margin|burden rate|loaded cost|payroll burden|loaded labor|structure my loaded|loaded bill|required bill rate|cost stack|markup leakage)\b/.test(c);
    }

    /** Price letters, memos, escalation emails — not hiring / regulatory defaults. */
    function isClientCommsAsk(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      return /\b(price increase|price (letter|notice|adjustment)|rate (increase|adjustment|notice)|mid-?term price|invoice follow|overdue invoice|client complaint|escalation email|client notice|draft (a )?(email|memo|letter|notice)|onboarding (walkthrough )?checklist|walkthrough checklist)\b/.test(c);
    }

    /** SDS / chemical asks — suppress Hire/pricing/fallback CTAs (no fake “crew safety card” print). */
    function isSafetyComplianceAsk(question, answer) {
      var q = String(question || '').toLowerCase();
      var a = String(answer || '').toLowerCase();
      var strongQ = /\b(sds|msds|safety data sheet|hazcom|ghs|ppe|crew safety|hazard communication|epa list n|chemical (safety|training|substitut)|disinfectant)\b/.test(q);
      /* Bid / pricing / hiring intents: only if the question itself is about SDS/chemicals. */
      if (/\b(bid|proposal|rfp|estimat|sq\.?\s*ft|square foot|pricing|bill rate|margin|wage|hire|job post|invoice|price increase)\b/.test(q)) {
        return strongQ;
      }
      if (strongQ) return true;
      /* Answer-only "OSHA" mentions are not enough — require SDS/crew-safety language. */
      return /\b(sds|msds|safety data sheet|crew safety card|hazcom|ppe training)\b/.test(a);
    }

    function isBidPacketAsk(question) {
      var q = String(question || '').toLowerCase();
      return /\b(bid packet|draft (a )?(bid|proposal)|write (a )?bid|cleaning bid|bid for (a |an )?\d)/.test(q);
    }

    function isHiringAsk(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      if (isSafetyComplianceAsk(question, answer)) return false;
      return /\b(hire|hiring|hire right|job (post|description|posting|ad)|interview question|offer letter|cleaning tech|janitor hire|wage floor|draft compliant job)\b/.test(c);
    }

    function isPricingCtaAsk(question, answer) {
      if (isBillRateAsk(question, answer)) return true;
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      return /\b(price|pricing|margin|sq\.?\s*ft|square foot|bill rate|loaded rate)\b/.test(c) &&
        !isSafetyComplianceAsk(question, answer) &&
        !isHiringAsk(question, answer) &&
        !isBidPacketAsk(question);
    }

    function billSpecFromAnswerText(question, answer) {
      var a = String(answer || '');
      var q = String(question || '');
      var billM = a.match(/required bill rate[^$\d]{0,40}\$?\s*([\d,]+(?:\.\d{1,2})?)\s*\/?\s*hr/i);
      var loadedM = a.match(/fully burdened(?: hourly)? cost[^$\d]{0,40}\$?\s*([\d,]+(?:\.\d{1,2})?)/i);
      var baseM = q.match(/\$?\s*([\d,]+(?:\.\d{1,2})?)\s*\/?\s*hr/i) ||
        a.match(/base direct labor[^$\d]{0,40}\$?\s*([\d,]+(?:\.\d{1,2})?)/i);
      var marginM = q.match(/(\d+(?:\.\d+)?)\s*%\s*(?:gross\s*)?margin/i) ||
        a.match(/at\s+(\d+(?:\.\d+)?)\s*%\s*gross margin/i) ||
        a.match(/1\s*[−\-]\s*0\.(\d{2})/);
      var bill = billM ? parseFloat(billM[1].replace(/,/g, ''), 10) : NaN;
      var loaded = loadedM ? parseFloat(loadedM[1].replace(/,/g, ''), 10) : NaN;
      var base = baseM ? parseFloat(baseM[1].replace(/,/g, ''), 10) : NaN;
      var margin = NaN;
      if (marginM) {
        if (marginM[1] && marginM[0].indexOf('1') === 0 && /1\s*[−\-]/.test(marginM[0])) {
          margin = parseInt(marginM[1], 10);
        } else {
          margin = parseFloat(marginM[1], 10);
        }
      }
      if (!(bill > 0)) return null;
      if (!(margin > 0) || margin >= 90) margin = 25;
      if (!(loaded > 0) && bill > 0 && margin > 0) loaded = Math.round(bill * (1 - margin / 100) * 100) / 100;
      if (!(base > 0) && loaded > 0) base = loaded;
      var naiveMarkup = Math.round(loaded * (1 + margin / 100) * 100) / 100;
      return {
        base: base,
        loaded: loaded,
        bill: bill,
        margin: margin,
        burdenPct: base > 0 ? Math.round(((loaded / base) - 1) * 1000) / 10 : 22,
        burdenAmt: Math.round((loaded - base) * 100) / 100,
        naiveMarkup: naiveMarkup,
        underbill: Math.round((bill - naiveMarkup) * 100) / 100,
        contradiction: null,
        fromAnswerText: true
      };
    }

    function parseOporaCtaMarker(text) {
      var m = String(text || '').match(/[\[⟦]\s*OPORA_CTA\|([^|]+)\|([^\]⟧]+)[\]⟧]/);
      if (!m) return null;
      return { label: m[1].trim(), href: m[2].trim() };
    }

    function stripOporaCtaMarkers(root) {
      if (!root) return;
      /* Walk all text-bearing nodes; remove leftover CTA tokens (any bracket style). */
      Array.prototype.slice.call(root.querySelectorAll('p, li, div, span')).forEach(function (el) {
        var t = el.textContent || '';
        if (!/OPORA_CTA\|/.test(t)) return;
        if (el.querySelector && el.querySelector('a.ask-handoff-primary, table, ul, ol')) {
          /* scrub token text only */
          el.childNodes && Array.prototype.forEach.call(el.childNodes, function (n) {
            if (n.nodeType === 3 && /OPORA_CTA\|/.test(n.nodeValue || '')) {
              n.nodeValue = String(n.nodeValue || '').replace(/[\[⟦]\s*OPORA_CTA\|[^\]⟧]+[\]⟧]/g, '').trim();
            }
          });
          return;
        }
        if (/^\s*[\[⟦]?\s*OPORA_CTA\|/.test(t.trim()) || /OPORA_CTA\|/.test(t)) {
          el.remove();
        }
      });
      /* Final pass: replace any remaining token strings in HTML */
      if (root.innerHTML && /OPORA_CTA\|/.test(root.innerHTML)) {
        root.innerHTML = root.innerHTML.replace(/[\[⟦]\s*OPORA_CTA\|[^\]⟧]+[\]⟧]/g, '');
      }
    }

    function isRfpAsk(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      return /\b(rfp|request for proposal|solicitation|proposal checklist)\b/.test(c);
    }

    function detectFacilityType(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      if (/\b(medical|clinic|hospital|healthcare|surgical|surgery|ambulatory|asc|or suite|dental)\b/.test(c)) return 'medical';
      if (/\b(school|education|k-12|university|library|municipal)\b/.test(c)) return 'education';
      if (/\b(office|corporate)\b/.test(c)) return 'office';
      if (/\b(warehouse|industrial|distribution|logistics)\b/.test(c)) return 'industrial';
      return null;
    }

    function detectBuildingLabel(question, answer) {
      var c = (String(question || '') + ' ' + String(answer || '')).toLowerCase();
      if (/\b(municipal|library)\b/.test(c)) return 'Municipal';
      if (/\b(ambulatory|surgery|asc|surgical)\b/.test(c)) return 'Surgery';
      if (/\b(warehouse|distribution|logistics)\b/.test(c)) return 'Warehouse';
      if (/\b(medical|clinic|hospital|healthcare)\b/.test(c)) return 'Medical';
      if (/\b(school|education|k-12|university)\b/.test(c)) return 'Education';
      if (/\b(office|corporate)\b/.test(c)) return 'Office';
      return null;
    }

    function burdenBreakdownLabel(stateCode, burdenPct) {
      if (stateCode === 'CA') return 'FICA (7.65%), FUTA (0.6%), CA SUTA, WC 9014, CA Sick Leave';
      if (stateCode === 'TX') return 'FICA/FUTA/TX SUTA/WC (~' + burdenPct + '%)';
      if (stateCode === 'GA') return 'FICA/FUTA/GA SUTA/NCCI 9014 (~' + burdenPct + '%)';
      if (stateCode === 'OH') return 'FICA/FUTA/OH SUTA/WC (~' + burdenPct + '%)';
      if (stateCode === 'PA') return 'FICA, FUTA, PA SUTA, WC 9014, medical PPE';
      if (stateCode === 'WA') return 'FICA/FUTA + WA L&I 6602-03 (~' + burdenPct + '%)';
      if (stateCode === 'NY') return 'FICA/FUTA/NY SUTA/WC 9014 (~' + burdenPct + '%)';
      return 'FICA, FUTA, SUTA, WC 9014 (~' + burdenPct + '%)';
    }

    function statePrettyName(stateCode) {
      var slug = stateCode && ASK_STATE_SLUGS[stateCode] ? ASK_STATE_SLUGS[stateCode] : null;
      if (!slug) return stateCode || '';
      return slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    function detectAskState(question, answer, meta) {
      /* Question intent wins — never let stale meta/profile CA override "Texas". */
      if (window.OporaGeo) {
        try {
          var extractFn = OporaGeo.extractFromQuestion || OporaGeo.extract;
          var g = extractFn(String(question || ''));
          if (g && (g.state_code || g.state)) {
            var scQ = String(g.state_code || g.state).toUpperCase();
            if (ASK_STATE_SLUGS[scQ]) return scQ;
          }
        } catch (e) {}
      }
      var qLower = String(question || '').toLowerCase();
      var namesQ = Object.keys(ASK_STATE_NAMES).sort(function (a, b) { return b.length - a.length; });
      for (var qi = 0; qi < namesQ.length; qi++) {
        if (qLower.indexOf(namesQ[qi]) !== -1) return ASK_STATE_NAMES[namesQ[qi]];
      }
      if (meta && Array.isArray(meta.detected_states) && meta.detected_states.length) {
        var ds0 = String(meta.detected_states[0] || '').toUpperCase().slice(0, 2);
        if (/^[A-Z]{2}$/.test(ds0) && ASK_STATE_SLUGS[ds0]) return ds0;
      }
      if (meta && meta.geo_state) {
        var gs = String(meta.geo_state).trim();
        if (/^[A-Za-z]{2}$/.test(gs)) return gs.toUpperCase();
        var code = gs.match(/\b([A-Za-z]{2})\b/);
        if (code && ASK_STATE_SLUGS[code[1].toUpperCase()]) return code[1].toUpperCase();
      }
      var blob = String(answer || '');
      var m2 = blob.match(/\b([A-Z]{2})\b/);
      if (m2 && ASK_STATE_SLUGS[m2[1]]) return m2[1];
      var lower = blob.toLowerCase();
      var names = Object.keys(ASK_STATE_NAMES).sort(function (a, b) { return b.length - a.length; });
      for (var i = 0; i < names.length; i++) {
        if (lower.indexOf(names[i]) !== -1) return ASK_STATE_NAMES[names[i]];
      }
      return null;
    }

    function formatAskMoney(n) {
      var v = Math.round(n * 100) / 100;
      return '$' + v.toFixed(2);
    }

    function hideAskExternalHandoff() {
      var band = document.querySelector('.opora-edge-wc-band--ask-handoff');
      if (band) band.hidden = true;
    }

    function showAskExternalHandoff() {
      var band = document.querySelector('.opora-edge-wc-band--ask-handoff');
      if (band) band.hidden = false;
    }

    function clearAskUtility(turn) {
      if (!turn) return;
      turn.classList.remove('is-answered');
      var band = turn.querySelector('.ask-estimate-band');
      if (band) {
        var packedRail = band.querySelector('.ask-rail');
        var split = turn.querySelector('.ask-a-split');
        if (packedRail && split) {
          split.insertBefore(packedRail, split.firstChild);
        }
        band.remove();
      }
      turn.querySelectorAll('.ask-ops-math, .ask-financial-table, .ask-handoff-row, .ask-a-cta-bar, .ask-handoff-primary--audit, .ask-handoff-secondary--audit').forEach(function (el) {
        el.remove();
      });
      hideAskExternalHandoff();
    }

    function parseBillRateSpec(question, answer) {
      var q = String(question || '');
      var a = String(answer || '');
      if (!isBillRateAsk(question, answer)) return null;
      var baseStr = extractWageRate(q) || extractWageRate(a);
      var margin = extractMarginPct(q) || extractMarginPct(a);
      var burdenFromText = extractBurdenPct(q) || extractBurdenPct(a);
      var loadedStr = extractLoadedAmount(a) || extractLoadedAmount(q);
      var base = baseStr ? parseFloat(baseStr, 10) : NaN;
      var loadedAns = loadedStr ? parseFloat(loadedStr, 10) : NaN;
      var burdenPct = (burdenFromText > 0 && burdenFromText < 80) ? burdenFromText : 22;
      if (!(base > 0)) return null;
      if (!(margin > 0) || margin >= 90) margin = 25;
      var loadedCanon = Math.round(base * (1 + burdenPct / 100) * 100) / 100;
      var loaded = loadedCanon;
      /* Prefer answer burdened/loaded cost when it is above base (never treat as bill rate) */
      if (loadedAns > base * 1.05 && loadedAns < base * 2.5) {
        loaded = Math.round(loadedAns * 100) / 100;
        burdenPct = Math.round(((loaded / base) - 1) * 1000) / 10;
      }
      /* Target Rate = Loaded / (1 − Margin) — drives Bottom Line, table, and CTA */
      var bill = Math.round((loaded / (1 - margin / 100)) * 100) / 100;
      var naiveMarkup = Math.round(loaded * (1 + margin / 100) * 100) / 100;
      var underbill = Math.round((bill - naiveMarkup) * 100) / 100;
      var leakMarginPct = Math.round(((loaded / naiveMarkup) * 1000) / 10) / 10;
      var answerBillStr = extractBillRateAmount(a);
      var answerBill = answerBillStr ? parseFloat(answerBillStr, 10) : NaN;
      var contradiction = (answerBill > 0 && Math.abs(answerBill - bill) > 0.5) ? answerBill : null;
      return {
        base: base,
        loaded: loaded,
        bill: bill,
        margin: margin,
        burdenPct: burdenPct,
        burdenAmt: Math.round((loaded - base) * 100) / 100,
        naiveMarkup: naiveMarkup,
        underbill: underbill,
        leakMarginPct: leakMarginPct,
        contradiction: contradiction
      };
    }

    function buildWageFloorMathHtml(baseWage, stateCode) {
      /* Legacy 3-box Ops Estimate — prefer Financial Scaffolding via buildWageBurdenSpec */
      var spec = buildWageBurdenSpec(baseWage);
      if (!spec) return '';
      return buildBillRateMathHtml(spec, stateCode);
    }

    /**
     * Only pack the legacy Ops Estimate ratecard with sources.
     * Financial Scaffolding stays in the memo column; Verified Sources stay in the split rail
     * (packing scaffold+rail into a band collapsed the two-column layout).
     */
    function packEstimateBand(turn) {
      if (!turn) return;
      var ratecard = turn.querySelector('.ask-ops-math--ratecard');
      if (!ratecard || ratecard.closest('.ask-estimate-band')) return;
      var rail = turn.querySelector('.ask-rail');
      var band = document.createElement('div');
      band.className = 'ask-estimate-band';
      ratecard.parentNode.insertBefore(band, ratecard);
      band.appendChild(ratecard);
      if (rail && String(rail.innerHTML || '').trim()) {
        band.appendChild(rail);
      }
    }

    /** Keep Verified Sources as the right column of ask-a-split (never nest in scaffold). */
    function ensureSourcesRail(turn, citations, geoLabel) {
      if (!turn) return null;
      var split = turn.querySelector('.ask-a-split');
      if (!split) return null;
      var main = turn.querySelector('.ask-a-main');
      var rail = turn.querySelector('.ask-rail');
      if (!rail) {
        rail = document.createElement('aside');
        rail.className = 'ask-rail citations-sidebar';
        rail.setAttribute('aria-label', 'Sources cited');
      }
      /* Unpack any prior band nesting that collapsed the dual-column layout */
      var band = turn.querySelector('.ask-scaffold-band');
      if (band) {
        while (band.firstChild) {
          var child = band.firstChild;
          if (child.classList && child.classList.contains('ask-rail')) {
            split.appendChild(child);
          } else {
            var body = turn.querySelector('.ask-a-body');
            if (body) body.insertBefore(child, band);
            else if (main) main.insertBefore(child, band);
            else band.removeChild(child);
          }
        }
        band.remove();
      }
      rail = turn.querySelector('.ask-rail') || rail;
      if (main && main.parentNode !== split) split.insertBefore(main, split.firstChild);
      if (rail.parentNode !== split) {
        if (main) split.appendChild(rail);
        else split.appendChild(rail);
      } else if (main && rail.compareDocumentPosition(main) & Node.DOCUMENT_POSITION_FOLLOWING) {
        split.insertBefore(main, rail);
      }
      rail.classList.remove('ask-rail--band');
      split.classList.remove('ask-a-split--band');
      updateRail(rail, citations || [], geoLabel || '');
      return rail;
    }

    /**
     * No-op unpack: Financial Scaffolding stays in the memo; Verified Sources stay
     * in the split right rail. (Prior packing collapsed the citation column.)
     */
    function packScaffoldSourcesBand(turn) {
      if (!turn) return;
      ensureSourcesRail(turn, (turn._askState && turn._askState.citations) || [], '');
    }

    function styleAuditCta(el, kind) {
      if (!el) return el;
      /* Chip-shaped tool handoffs (deterministic detectors / compiler only). */
      el.classList.add('ask-tool-chip');
      el.setAttribute('style',
        kind === 'primary'
          ? 'display:inline-flex!important;align-items:center;justify-content:center;' +
            'min-height:34px;padding:7px 14px;border-radius:999px;border:1px solid #0B6E63;' +
            'background:#0B6E63!important;color:#fff!important;font:650 12.5px/1.3 Inter,Barlow,sans-serif;' +
            'text-decoration:none!important;white-space:nowrap;cursor:pointer;opacity:1!important;' +
            'visibility:visible!important;letter-spacing:0!important;text-transform:none!important;'
          : 'display:inline-flex!important;align-items:center;justify-content:center;' +
            'min-height:34px;padding:7px 14px;border-radius:999px;border:1px solid #C5CDD6;' +
            'background:#fff!important;color:#0F1217!important;font:600 12.5px/1.3 Inter,Barlow,sans-serif;' +
            'text-decoration:none!important;white-space:nowrap;cursor:pointer;opacity:1!important;' +
            'visibility:visible!important;letter-spacing:0!important;text-transform:none!important;'
      );
      return el;
    }

    function buildBillRateMathHtml(spec, stateCode) {
      if (!spec) return '';
      var rows = [
        { component: 'Base Direct Wage', detail: 'Stated input wage', rate: formatAskMoney(spec.base) + '/hr' },
        {
          component: 'Statutory Burden (' + spec.burdenPct + '%)',
          detail: burdenBreakdownLabel(stateCode, spec.burdenPct),
          rate: '+' + formatAskMoney(spec.burdenAmt) + '/hr'
        },
        { component: 'Fully Burdened Cost', detail: 'Direct labor break-even cost', rate: formatAskMoney(spec.loaded) + '/hr' },
        {
          component: 'Required Bill Rate (Divisor)',
          detail: formatAskMoney(spec.loaded) + ' / (1 \u2212 ' + (spec.margin / 100).toFixed(2) + ')',
          rate: formatAskMoney(spec.bill) + '/hr'
        },
        {
          component: 'Markup Leakage Warning',
          detail: spec.margin + '% flat markup yields ' + formatAskMoney(spec.naiveMarkup) + '/hr',
          rate: '\u2212' + formatAskMoney(spec.underbill) + '/hr',
          warning: true
        }
      ];
      return buildFinancialBreakdownHtml(rows);
    }

    function normalizeFinRow(row) {
      if (!row || typeof row !== 'object') return null;
      var component = row.component || row.metric || '';
      var detail = row.detail || row.breakdown || '';
      var rate = row.rate || row.value || '';
      if (!component && !rate) return null;
      return {
        component: String(component),
        detail: String(detail),
        rate: String(rate),
        highlight: !!(row.highlight || /Required Bill Rate|Gross Margin Divisor|Divisor/i.test(component)),
        warning: !!(row.warning || /Leakage|Warning|PROHIBITED|UNLAWFUL/i.test(component) || /PROHIBITED|UNLAWFUL/i.test(rate))
      };
    }

    function extractFinancialScaffolding(content) {
      var raw = String(content || '');
      var financialRegex =
        /(?:\*{0,2}Financial scaffolding\*{0,2}\s*\n+\s*)?(?:\|\s*)?Metric\s*(?:\||\s{2,})\s*Calculation\s*\/\s*Breakdown\s*(?:\||\s{2,})\s*Value\s*(?:\||)?([\s\S]*?)(?=(?:\n\s*Target Rate|\n\s*\*{0,2}Compliance|\n\s*\*{0,2}SOW|\n\s*\*{0,2}Competitor|\n\s*\*{0,2}Risks|\n\s*\*{0,2}What to do|$))/i;
      var match = raw.match(financialRegex);
      var rows = [];
      if (match) {
        var chunk = match[1] || '';
        chunk.split(/\n/).forEach(function (line) {
          line = line.replace(/^\||\|$/g, '').trim();
          if (!line || /^[-|:\s]+$/.test(line)) return;
          if (/^Metric\b/i.test(line) && /Calculation/i.test(line)) return;
          var parts = line.indexOf('|') >= 0
            ? line.split('|').map(function (p) { return p.trim(); }).filter(Boolean)
            : line.split(/\s{2,}|\t+/).map(function (p) { return p.trim(); }).filter(Boolean);
          if (parts.length >= 3) {
            var metric = parts[0];
            var value = parts[parts.length - 1];
            var breakdown = parts.slice(1, -1).join(' ');
            rows.push({
              component: metric,
              detail: breakdown,
              rate: value,
              highlight: /divisor|required bill/i.test(metric),
              warning: /leakage|warning/i.test(metric)
            });
          }
        });
      }
      /* Also harvest from known metric lines if header match failed */
      if (!rows.length) {
        var lineRe =
          /^(Base Direct (?:Wage|Labor)|Statutory Burden[^$\n]*|Fully Burdened Cost|Gross Margin Divisor|Required Bill Rate[^$\n]*|Markup Leakage(?: Warning)?)\s{2,}(.+?)\s{2,}(\$?[\d.,]+(?:\s*\/\s*hr)?(?:\s*[→~\-−].*)?)\s*$/gim;
        var m;
        while ((m = lineRe.exec(raw))) {
          rows.push({
            component: m[1].trim(),
            detail: m[2].trim(),
            rate: m[3].trim(),
            highlight: /divisor|required bill/i.test(m[1]),
            warning: /leakage|warning/i.test(m[1])
          });
        }
      }
      var cleanContent = raw
        .replace(/\*{0,2}Financial scaffolding\*{0,2}\s*\n+/ig, '\n')
        .replace(/(?:\|\s*)?Metric\s*(?:\||\s{2,})\s*Calculation\s*\/\s*Breakdown\s*(?:\||\s{2,})\s*Value\s*(?:\||)?[\s\S]*?(?=\n\s*Target Rate|\n\s*\*{0,2}Compliance|\n\s*\*{0,2}SOW|\n\s*\*{0,2}Competitor|\n\s*\*{0,2}Risks|\n\s*\*{0,2}What to do|$)/i, '\n')
        .replace(/\n\s*Target Rate\s*=\s*Base[^\n]*/ig, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
      return { cleanContent: cleanContent, tableRows: rows.length ? rows : null };
    }

    function buildFinancialBreakdownHtml(rows, opts) {
      opts = opts || {};
      if (!Array.isArray(rows) || !rows.length) return '';
      var normalized = rows.map(normalizeFinRow).filter(Boolean);
      if (!normalized.length) return '';
      var footnoteHtml = opts.footnote
        ? String(opts.footnote)
        : 'Target Rate = Base &times; (1 + Burden) / (1 &minus; Margin). CTA uses this divisor — never loaded cost.';
      /*
       * One flex row per metric — same basis on every row so Metric / Breakdown / Value
       * left-align under their labels with a fixed gutter. Never space-padded plaintext.
       */
      var wrapStyle =
        'margin:8px 0 12px;padding:0;overflow:hidden;border-radius:10px;' +
        'border:1px solid rgba(15,18,23,0.12);background:#fff;' +
        'display:block!important;box-sizing:border-box!important;';
      var headStyle =
        'display:block!important;background:#F4F6F8;padding:10px 14px;' +
        'border-bottom:1px solid rgba(15,18,23,0.10);' +
        'font:700 10px/1.2 Inter,Barlow,sans-serif;letter-spacing:0.08em;' +
        'text-transform:uppercase;color:#5B6570;text-align:left!important;';
      var stackStyle =
        'display:flex!important;flex-direction:column!important;width:100%!important;' +
        'box-sizing:border-box!important;margin:0;padding:0;';
      var rowStyle =
        'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;' +
        'align-items:flex-start!important;justify-content:flex-start!important;' +
        'gap:16px!important;width:100%!important;box-sizing:border-box!important;' +
        'padding:10px 14px!important;margin:0!important;' +
        'border-bottom:1px solid rgba(15,18,23,0.07)!important;';
      var headRowStyle =
        rowStyle +
        'background:#F4F6F8!important;border-bottom:1px solid rgba(15,18,23,0.10)!important;';
      var colMetric =
        'flex:0 0 28%!important;width:28%!important;max-width:28%!important;' +
        'box-sizing:border-box!important;text-align:left!important;margin:0!important;padding:0!important;';
      var colDetail =
        'flex:1 1 auto!important;min-width:0!important;' +
        'box-sizing:border-box!important;text-align:left!important;margin:0!important;padding:0!important;';
      var colValue =
        'flex:0 0 140px!important;width:140px!important;max-width:140px!important;' +
        'box-sizing:border-box!important;text-align:right!important;margin:0!important;padding:0!important;' +
        'white-space:normal!important;overflow-wrap:anywhere!important;word-break:break-word!important;' +
        'font-variant-numeric:tabular-nums;';
      var thMetric =
        colMetric +
        'font:700 11px/1.3 Inter,Barlow,sans-serif!important;color:#5B6570!important;' +
        'text-transform:uppercase;letter-spacing:0.04em;';
      var thDetail =
        colDetail +
        'font:700 11px/1.3 Inter,Barlow,sans-serif!important;color:#5B6570!important;' +
        'text-transform:uppercase;letter-spacing:0.04em;';
      var thValue =
        colValue +
        'font:700 11px/1.3 Inter,Barlow,sans-serif!important;color:#5B6570!important;' +
        'text-transform:uppercase;letter-spacing:0.04em;';
      var tdMetric =
        colMetric +
        'font:700 13px/1.4 Inter,Barlow,sans-serif!important;color:#0F1217!important;';
      var tdDetail =
        colDetail +
        'font:500 12.5px/1.45 Inter,Barlow,sans-serif!important;color:#5B6570!important;';
      var tdValue =
        colValue +
        'font:700 13px/1.4 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace!important;color:#0F1217!important;';
      var footStyle =
        'display:block!important;margin:0;padding:10px 14px;background:#F7F9FB;' +
        'border-top:1px solid rgba(15,18,23,0.08);font:500 11.5px/1.45 Inter,Barlow,sans-serif;' +
        'color:#5B6570;text-align:left!important;';
      var rowsHtml =
        '<div class="ask-fin-row ask-fin-row--head" role="row" style="' + headRowStyle + '">' +
          '<div class="ask-fin-col-metric" role="columnheader" style="' + thMetric + '">Metric</div>' +
          '<div class="ask-fin-col-detail" role="columnheader" style="' + thDetail + '">Calculation / Breakdown</div>' +
          '<div class="ask-fin-col-value" role="columnheader" style="' + thValue + '">Value</div>' +
        '</div>';
      normalized.forEach(function (row) {
        var rowBg = 'background:#fff!important;';
        var mStyle = tdMetric;
        var dStyle = tdDetail;
        var vStyle = tdValue;
        var rowClass = 'ask-fin-row';
        if (row.highlight) {
          rowBg = 'background:rgba(11,110,99,0.07)!important;';
          mStyle += 'color:#0B6E63!important;';
          vStyle += 'color:#0B6E63!important;';
          rowClass += ' ask-fin-row--target';
        }
        if (row.warning) {
          rowBg = 'background:rgba(180,35,24,0.05)!important;';
          mStyle += 'color:#9B1C1C!important;';
          vStyle += 'color:#B42318!important;';
          rowClass += ' ask-fin-row--warn';
        }
        if (/Fully Burdened|Net Owner Take-Home|Gross Revenue Ceiling/i.test(row.component) && !row.highlight && !row.warning) {
          rowBg = 'background:rgba(15,18,23,0.03)!important;';
          rowClass += ' ask-fin-row--subtotal';
        }
        rowsHtml +=
          '<div class="' + rowClass + '" role="row" style="' + rowStyle + rowBg + '">' +
            '<div class="ask-fin-metric" role="cell" style="' + mStyle + '">' + escapeHtml(row.component) + '</div>' +
            '<div class="ask-fin-detail" role="cell" style="' + dStyle + '">' + escapeHtml(row.detail) + '</div>' +
            '<div class="ask-fin-value" role="cell" style="' + vStyle + '">' + escapeHtml(row.rate) + '</div>' +
          '</div>';
      });
      return (
        '<div class="ask-ops-math ask-ops-math--scaffold ask-financial-table" role="region" aria-label="Financial scaffolding" data-ask-fin-once="1" data-fin-layout="flex-rows-v3" style="' + wrapStyle + '">' +
          '<div class="ask-ops-math-label" style="' + headStyle + '">Financial scaffolding</div>' +
          '<div class="ask-md-table-wrap" style="display:block!important;overflow-x:hidden;-webkit-overflow-scrolling:touch;">' +
            '<div class="ask-fin-stack ask-fin-table ask-scaffold" role="table" style="' + stackStyle + '">' +
              rowsHtml +
            '</div>' +
          '</div>' +
          '<p class="ask-fin-footnote" style="' + footStyle + '">' + footnoteHtml + '</p>' +
        '</div>'
      );
    }

    function hydrateRawMarkdownLinks(root) {
      if (!root) return;
      var nodes = root.querySelectorAll('p, li, td, th, div');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.querySelector('a, table, ul, ol')) return;
        var text = el.textContent || '';
        if (text.indexOf('](') < 0) return;
        var rebuilt = text.replace(/\[([^\]]+)\]\((\/(?:pages|blogs)\/[^)\s]+)\)/g, function (_m, label, href) {
          return '<a class="ask-md-link ask-handoff-primary" href="' + escapeHtml(href) + '">' + escapeHtml(label) + '</a>';
        });
        if (rebuilt !== text) el.innerHTML = rebuilt;
      });
    }

    function isAsciiFinancialScaffoldText(text) {
      var t = String(text || '');
      if (/⟦OPORA_RATE_STACK⟧|\[\[OPORA_RATE_STACK\]\]/i.test(t)) return true;
      if (/Financial scaffolding/i.test(t) && /Base Direct Wage|Gross Margin Divisor|Markup Leakage/i.test(t)) return true;
      if (/Metric/.test(t) && /Calculation\s*\/\s*Breakdown/.test(t) && /Base Direct Wage/i.test(t)) return true;
      if (/Cost Stack|Markup Leakage Audit/i.test(t) && /Base Direct (?:Labor|Wage)/i.test(t)) return true;
      if (/Target Rate\s*=\s*Base/i.test(t) && /Base Direct/i.test(t)) return true;
      return false;
    }

    function purgeFinancialScaffoldNodes(body) {
      if (!body) return;
      body.querySelectorAll(
        '.ask-ops-math, .ask-ops-math--scaffold, .ask-ops-math--ratecard, .ask-financial-table, ' +
        '.ask-md-table-wrap.ask-financial-table, [data-ask-fin-once], table.ask-fin-table, .ask-fin-grid, .ask-fin-stack'
      ).forEach(function (el) {
        var wrap = el.closest('.ask-ops-math, .ask-financial-table, .ask-md-table-wrap, [data-ask-fin-once]') || el;
        if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
        else if (el.parentNode) el.parentNode.removeChild(el);
      });
      Array.prototype.slice.call(body.querySelectorAll('p, div, h3, h4, strong, pre, code, li')).forEach(function (el) {
        if (el.closest && el.closest('[data-ask-fin-once]')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Financial scaffolding$/i.test(t)) { el.remove(); return; }
        if (/^Target Rate\s*=\s*Base/i.test(t)) { el.remove(); return; }
        if (/Financial stack loads as a structured table/i.test(t)) { el.remove(); return; }
        if (/OPORA_RATE_STACK/i.test(t)) { el.remove(); return; }
        if (isAsciiFinancialScaffoldText(t) && !el.querySelector('table, .ask-fin-grid, .ask-fin-stack')) el.remove();
      });
      Array.prototype.slice.call(body.children).forEach(function (el) {
        if (el.closest && el.getAttribute && el.getAttribute('data-ask-fin-once')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (isAsciiFinancialScaffoldText(t) && !el.querySelector('table, .ask-fin-grid, .ask-fin-stack, [data-ask-fin-once]')) el.remove();
      });
    }

    function parseAsciiFinancialScaffold(text) {
      var t = String(text || '').replace(/\u00a0/g, ' ');
      var rows = [];
      var patterns = [
        { re: /Base Direct (?:Wage|Labor)[^\n$]*?(\$\s*[\d,]+\.\d{2}\s*\/\s*hr)/i, component: 'Base Direct Wage', detail: 'Stated input wage' },
        { re: /Statutory Burden[^\n$]*?(\$\s*[\d,]+\.\d{2}\s*\/\s*hr)/i, component: 'Statutory Burden', detail: 'Statutory burden on direct wage' },
        { re: /Fully Burdened Cost[^\n$]*?(\$\s*[\d,]+\.\d{2}\s*\/\s*hr)/i, component: 'Fully Burdened Cost', detail: 'Direct labor break-even cost' },
        { re: /(?:Gross Margin Divisor|Required Bill Rate)[^\n$]*?(\$\s*[\d,]+\.\d{2}\s*\/\s*hr)/i, component: 'Gross Margin Divisor', detail: 'Guarantees target gross margin' },
        { re: /Markup Leakage[^\n$]*?((?:-\s*)?\$\s*[\d,]+\.\d{2}\s*\/\s*hr|~?\s*[\d.]+%\s*GM)/i, component: 'Markup Leakage Warning', detail: 'Flat markup vs divisor leakage' }
      ];
      patterns.forEach(function (p) {
        var m = t.match(p.re);
        if (m) rows.push({ component: p.component, detail: p.detail, rate: m[1].replace(/\s+/g, '') });
      });
      return rows.length ? rows : null;
    }

    function upgradeAsciiFinancialScaffolds(root, preferredRows) {
      if (!root) return false;
      var upgraded = false;
      var kids = Array.prototype.slice.call(root.children);
      var i = 0;
      while (i < kids.length) {
        var el = kids[i];
        if (!el || !el.parentNode) { i++; continue; }
        if (el.querySelector && el.querySelector('table.ask-fin-table, .ask-fin-grid, .ask-fin-stack, .ask-financial-table, [data-ask-fin-once]')) { i++; continue; }
        var text = el.textContent || '';
        var start = i;
        var blob = text;
        var end = i;
        if (isAsciiFinancialScaffoldText(text) || /^Financial scaffolding$/i.test(text.trim()) || /^Cost Stack/i.test(text.trim()) || /⟦OPORA_RATE_STACK⟧/i.test(text)) {
          end = i;
          while (end + 1 < kids.length) {
            var next = kids[end + 1];
            var ntxt = (next && next.textContent) || '';
            if (/^Compliance\s*&\s*classification|^SOW boundaries|^Competitor|^Risks|^What to do next/i.test(ntxt.trim())) break;
            if (next.querySelector && next.querySelector('table.ask-fin-table, .ask-fin-grid, .ask-fin-stack, [data-ask-fin-once]')) break;
            blob += '\n' + ntxt;
            end += 1;
            if (/Target Rate\s*=\s*Base/i.test(ntxt)) break;
          }
          var rows = preferredRows;
          if (!rows || !rows.length) rows = parseAsciiFinancialScaffold(blob);
          var html = rows && rows.length ? buildFinancialBreakdownHtml(rows) : '';
          if (html) {
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var node = wrap.firstChild;
            var anchor = kids[start];
            if (node && anchor && anchor.parentNode) {
              anchor.parentNode.insertBefore(node, anchor);
              for (var j = start; j <= end; j++) {
                if (kids[j] && kids[j].parentNode) kids[j].parentNode.removeChild(kids[j]);
              }
              upgraded = true;
              kids = Array.prototype.slice.call(root.children);
              i = 0;
              continue;
            }
          } else if (/⟦OPORA_RATE_STACK⟧|\[\[OPORA_RATE_STACK\]\]/i.test(text)) {
            el.remove();
            kids = Array.prototype.slice.call(root.children);
            continue;
          }
        }
        i++;
      }
      return upgraded;
    }

    function parseSmashedPipeTable(text) {
      var raw = String(text || '').replace(/\s+/g, ' ').trim();
      if (raw.indexOf('|') < 0) return null;
      var parts = raw.split('|').map(function (p) { return p.trim(); }).filter(Boolean);
      if (parts.length < 6) return null;
      var rows = [];
      var i = 0;
      /* Skip header + separator cells */
      while (i < parts.length && !/^Base Direct (?:Labor|Wage)$/i.test(parts[i])) {
        if (/^---+$/.test(parts[i])) { i++; continue; }
        i++;
      }
      while (i + 2 < parts.length) {
        if (/^---+$/.test(parts[i])) { i++; continue; }
        var component = parts[i];
        var detail = parts[i + 1];
        var rate = parts[i + 2];
        if (/Cost Component|Rate \/ Source|Hourly Impact|Metric|Calculation/i.test(component)) {
          i += 1;
          continue;
        }
        rows.push({ component: component, detail: detail, rate: rate });
        i += 3;
      }
      return rows.length ? rows : null;
    }

    function upgradeSmashedPipeTables(root, preferredRows) {
      if (!root) return false;
      var upgraded = upgradeAsciiFinancialScaffolds(root, preferredRows);
      var nodes = Array.prototype.slice.call(root.querySelectorAll('p, div, li, span, pre'));
      nodes.forEach(function (el) {
        if (el.querySelector && el.querySelector('table')) return;
        var text = el.textContent || '';
        var isSentinel = /⟦OPORA_RATE_STACK⟧|\[\[OPORA_RATE_STACK\]\]/i.test(text);
        var isPipeBlob = /\|?\s*Cost Component\s*\|/i.test(text) ||
          (/\|/.test(text) && /Base Direct (?:Labor|Wage)/i.test(text) && /Required Bill Rate|Gross Margin Divisor/i.test(text));
        var isAscii = isAsciiFinancialScaffoldText(text);
        if (!isSentinel && !isPipeBlob && !isAscii) return;
        var rows = preferredRows;
        if (!rows || !rows.length) rows = parseSmashedPipeTable(text) || parseAsciiFinancialScaffold(text);
        var html = rows && rows.length
          ? buildFinancialBreakdownHtml(rows)
          : '';
        if (!html) {
          if (isSentinel) el.remove();
          return;
        }
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        if (wrap.firstChild) {
          el.parentNode.replaceChild(wrap.firstChild, el);
          upgraded = true;
        }
      });
      return upgraded;
    }

    function stripPipeOrSentinelNodes(body) {
      if (!body) return;
      Array.prototype.slice.call(body.children).forEach(function (el) {
        var text = el.textContent || '';
        if (/⟦OPORA_RATE_STACK⟧|\[\[OPORA_RATE_STACK\]\]/i.test(text)) {
          el.remove();
          return;
        }
        if (isAsciiFinancialScaffoldText(text) && !el.querySelector('table')) {
          el.remove();
          return;
        }
        if (/\|?\s*Cost Component\s*\|/i.test(text) ||
          (text.indexOf('|') >= 0 && /Base Direct (?:Labor|Wage)/i.test(text) && /Fully Burdened Cost/i.test(text))) {
          el.remove();
        }
      });
    }

    function mountFinancialTableInFindings(turn, html, opts) {
      opts = opts || {};
      if (!html) return;
      var body = turn.querySelector('.ask-a-body');
      if (!body) return;
      purgeFinancialScaffoldNodes(body);
      stripPipeOrSentinelNodes(body);
      /* Do NOT call upgradeAsciiFinancialScaffolds here — that re-creates a second table. */

      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var tableEl = wrap.firstChild;
      if (!tableEl) return;

      var kids = Array.prototype.slice.call(body.children);
      var keyIdx = -1;
      for (var i = 0; i < kids.length; i++) {
        var txt = (kids[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Key findings:?$/i.test(txt) || (/^Key findings\b/i.test(txt) && txt.length < 48)) {
          keyIdx = i;
          break;
        }
      }
      if (keyIdx < 0) {
        /* Prefer after title/intro: insert after first heading block when possible */
        if (kids.length > 1) kids[0].insertAdjacentElement('afterend', tableEl);
        else body.insertBefore(tableEl, body.firstChild);
        packScaffoldSourcesBand(turn);
        return;
      }

      /* Solo owner cards: title/intro → scaffolding → Key findings narrative */
      if (opts.beforeKeyFindings) {
        kids[keyIdx].insertAdjacentElement('beforebegin', tableEl);
        var finsEarly = body.querySelectorAll('[data-ask-fin-once]');
        for (var fe = 1; fe < finsEarly.length; fe++) {
          var killE = finsEarly[fe].closest('[data-ask-fin-once]') || finsEarly[fe];
          if (killE.parentNode) killE.parentNode.removeChild(killE);
        }
        packScaffoldSourcesBand(turn);
        return;
      }

      var insertAfter = kids[keyIdx];
      var cursor = kids[keyIdx + 1];
      while (cursor) {
        var ctxt = (cursor.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Compliance\s*&\s*classification/i.test(ctxt)) break;
        var isLabel = /Cost Stack|Markup Leakage|Financial scaffolding/i.test(ctxt) && ctxt.length < 80;
        var isStackList = cursor.tagName === 'UL' && /Base Direct|Fully Burdened|Required Bill Rate|Statutory Burden|Gross Margin|Markup Leakage/i.test(ctxt);
        var isMdTable = cursor.classList && (cursor.classList.contains('ask-md-table-wrap') || cursor.classList.contains('ask-financial-table'));
        var isPipeOrSentinel = /⟦OPORA_RATE_STACK⟧|\|?\s*(?:Cost Component|Metric)\s*\|/i.test(ctxt) ||
          (ctxt.indexOf('|') >= 0 && /Base Direct/i.test(ctxt));
        var isAsciiBlock = isAsciiFinancialScaffoldText(ctxt) || /Target Rate\s*=\s*Base/i.test(ctxt);
        var isPlaceholder = /Financial stack loads as a structured table/i.test(ctxt);
        var isFinTable = !!(cursor.querySelector && cursor.querySelector('table.ask-fin-table, table.ask-md-table, .ask-fin-grid, .ask-fin-stack, [data-ask-fin-once]'));
        if (isLabel || isStackList || isMdTable || isPipeOrSentinel || isAsciiBlock || isPlaceholder || isFinTable) {
          var drop = cursor;
          cursor = cursor.nextElementSibling;
          drop.parentNode && drop.parentNode.removeChild(drop);
          continue;
        }
        break;
      }
      insertAfter.insertAdjacentElement('afterend', tableEl);
      var fins = body.querySelectorAll('[data-ask-fin-once]');
      for (var fi = 1; fi < fins.length; fi++) {
        var kill = fins[fi].closest('[data-ask-fin-once]') || fins[fi];
        if (kill.parentNode) kill.parentNode.removeChild(kill);
      }
      packScaffoldSourcesBand(turn);
    }

    function appendAskUtilityHtml(turn, html) {
      mountFinancialTableInFindings(turn, html);
    }

    function insertAskHandoffRow(turn, html) {
      turn.querySelectorAll('.ask-handoff-row--incard, .ask-handoff-row--footer, .ask-a-cta-bar, .ask-handoff-primary--audit, .ask-handoff-secondary--audit').forEach(function (el) {
        el.remove();
      });
      var row = document.createElement('div');
      row.className = 'ask-handoff-row ask-handoff-row--footer ask-handoff-row--incard';
      row.innerHTML = html;

      /* In-card: keep CTAs in the left column under the memo (not under the sources rail) */
      var askMain = turn.querySelector('.ask-a-main');
      var askA = turn.querySelector('.ask-a');
      if (askMain) {
        var bar = document.createElement('div');
        bar.className = 'ask-a-cta-bar';
        bar.appendChild(row);
        askMain.appendChild(bar);
      } else if (askA) {
        var bar2 = document.createElement('div');
        bar2.className = 'ask-a-cta-bar';
        bar2.appendChild(row);
        askA.appendChild(bar2);
      } else {
        turn.appendChild(row);
      }

      Array.prototype.forEach.call(row.querySelectorAll('a.ask-handoff-primary'), function (a) {
        styleAuditCta(a, 'primary');
      });
      Array.prototype.forEach.call(row.querySelectorAll('a.ask-handoff-secondary'), function (a) {
        styleAuditCta(a, 'secondary');
      });

      return row;
    }

    function mountBidDrafterCta(turn, billSpec, compilerState, stateCode, facilityType, building, answerText) {
      if (!turn) return null;
      var marker = parseOporaCtaMarker(answerText || '');
      var payload = compilerState && compilerState.downstream_payload;
      var bill = billSpec && billSpec.bill > 0 ? billSpec.bill : null;
      if (!(bill > 0) && payload && payload.serialized_query_string) {
        var rateM = String(payload.serialized_query_string).match(/[?&]rate=([\d.]+)/);
        if (rateM) bill = parseFloat(rateM[1], 10);
      }
      if (!(bill > 0) && marker) {
        var mRate = marker.href.match(/[?&]rate=([\d.]+)/);
        if (mRate) bill = parseFloat(mRate[1], 10);
      }
      if (!(bill > 0) && !(marker && marker.href) && !(payload && payload.serialized_query_string)) {
        return null;
      }

      var spec = billSpec || { bill: bill || 0, base: 0, loaded: 0, margin: 0 };
      if (!(spec.bill > 0) && bill > 0) spec.bill = bill;

      var bidUrl = marker && marker.href
        ? withPreviewParam(marker.href)
        : (payload && payload.serialized_query_string
          ? withPreviewParam('/pages/bid-drafter' + payload.serialized_query_string)
          : buildBidDrafterUrl(spec, stateCode, facilityType, building));
      var ctaLabel = (marker && marker.label) ||
        (payload && payload.cta_label) ||
        ('Draft proposal with ' + formatAskMoney(spec.bill) + '/hr \u2192 Bid Drafter');
      var secondary = buildSecondaryHandoff(stateCode, building);
      var row = insertAskHandoffRow(turn,
        '<a class="ask-handoff-primary" href="' + escapeHtml(bidUrl) + '">' + escapeHtml(ctaLabel) + '</a>' +
        '<a class="ask-handoff-secondary" href="' + escapeHtml(secondary.href) + '">' + escapeHtml(secondary.label) + '</a>'
      );
      wireToolHandoff(row.querySelector('.ask-handoff-primary'), 'bid-drafter', {
        source_tool: 'ask-opora',
        bill_rate: spec.bill,
        hourlyRate: spec.bill,
        base_wage: spec.base || undefined,
        wage_rate: spec.base || undefined,
        loaded_cost: spec.loaded || undefined,
        gross_margin: spec.margin || undefined,
        state: stateCode || undefined,
        facility_type: facilityType || undefined,
        building: building || undefined,
        deal_vertical: facilityType === 'medical' ? 'healthcare' : facilityType || undefined
      });
      wireToolHandoff(row.querySelector('.ask-handoff-secondary'), secondary.tool || 'secondary-handoff', {
        source_tool: 'ask-opora',
        state: stateCode || undefined
      });

      stripOporaCtaMarkers(turn.querySelector('.ask-a-body'));
      hideAskExternalHandoff();
      return row;
    }

    function withPreviewParam(url) {
      try {
        var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (!previewId) return url;
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(previewId);
      } catch (e) {
        return url;
      }
    }

    function buildBillRateCalcUrl(wage, stateCode) {
      var params = new URLSearchParams();
      params.set('from', 'ask-opora');
      params.set('hourlyRate', wage);
      params.set('wage', wage);
      params.set('wage_rate', wage);
      if (stateCode) params.set('state', stateCode);
      try {
        var payload = {
          source_tool: 'ask-opora',
          base_wage: wage,
          wage_rate: wage,
          hourly_rate: wage,
          hourlyRate: wage
        };
        if (stateCode) payload.state = stateCode;
        params.set('prefill', JSON.stringify(payload));
      } catch (e) {}
      return withPreviewParam('/pages/bill-rate-calculator?' + params.toString());
    }

    function buildBidDrafterUrl(spec, stateCode, facilityType, building) {
      var params = new URLSearchParams();
      params.set('from', 'ask-opora');
      if (spec && spec.bill > 0) {
        params.set('rate', String(spec.bill));
        params.set('hourlyRate', String(spec.bill));
      }
      if (spec && spec.base > 0) {
        params.set('wage', String(spec.base));
        params.set('wage_rate', String(spec.base));
      }
      if (spec && spec.loaded > 0) params.set('cost', String(spec.loaded));
      if (spec && spec.margin > 0) params.set('margin', String(spec.margin));
      if (stateCode) params.set('state', stateCode);
      if (facilityType) params.set('type', facilityType);
      if (building) params.set('building', building);
      try {
        var payload = {
          source_tool: 'ask-opora'
        };
        if (spec && spec.bill > 0) {
          payload.bill_rate = spec.bill;
          payload.hourlyRate = spec.bill;
          payload.hourly_rate = spec.bill;
        }
        if (spec && spec.base > 0) {
          payload.base_wage = spec.base;
          payload.wage_rate = spec.base;
          payload.wage = spec.base;
        }
        if (spec && spec.loaded > 0) payload.loaded_cost = spec.loaded;
        if (spec && spec.margin > 0) {
          payload.gross_margin = spec.margin;
          payload.target_margin = spec.margin;
        }
        if (stateCode) payload.state = stateCode;
        if (facilityType) {
          payload.facility_type = facilityType;
          payload.building_type = facilityType;
          payload.deal_vertical = facilityType === 'medical' ? 'healthcare' : facilityType;
        }
        if (building) payload.building = building;
        params.set('prefill', JSON.stringify(payload));
      } catch (e) {}
      return withPreviewParam('/pages/bid-drafter?' + params.toString());
    }

    function buildSowGuideUrl(stateCode) {
      return withPreviewParam('/blogs/opora-field-guide/commercial-cleaning-scope-of-work-contract-clauses');
    }

    function buildSecondaryHandoff(stateCode, building) {
      var pretty = statePrettyName(stateCode);
      if (stateCode === 'CA' || building === 'Municipal') {
        return {
          href: buildSowGuideUrl(stateCode),
          label: pretty ? ('Open ' + pretty + ' SOW Guide \u2192') : 'Open SOW Guide \u2192'
        };
      }
      if (pretty) {
        return {
          href: buildWagesUrl(stateCode),
          label: 'Review ' + pretty + ' wage tables \u2192'
        };
      }
      return {
        href: buildSowGuideUrl(stateCode),
        label: 'Open SOW Guide \u2192'
      };
    }

    function buildHireRightUrl(wage, stateCode) {
      var params = new URLSearchParams();
      params.set('from', 'ask-opora');
      if (wage) {
        params.set('wage', String(wage));
        params.set('base_wage', String(wage));
        params.set('wage_rate', String(wage));
        params.set('hourlyRate', String(wage));
      }
      if (stateCode) params.set('state', stateCode);
      try {
        var payload = { source_tool: 'ask-opora' };
        if (wage) {
          payload.base_wage = wage;
          payload.wage = wage;
          payload.wage_rate = wage;
          payload.hourly_rate = wage;
          payload.hourlyRate = wage;
          payload.target_wage = wage;
        }
        if (stateCode) payload.state = stateCode;
        params.set('prefill', JSON.stringify(payload));
      } catch (e) {}
      return withPreviewParam('/pages/hire-right?' + params.toString());
    }

    function buildWagesUrl(stateCode) {
      var slug = stateCode && ASK_STATE_SLUGS[stateCode] ? ASK_STATE_SLUGS[stateCode] : null;
      var path = slug ? '/pages/janitorial-wages-' + slug : '/pages/janitorial-wages';
      return withPreviewParam(path);
    }

    function wireToolHandoff(linkEl, slug, payload) {
      if (!linkEl || !slug) return;
      if (linkEl._askToolWired) return;
      linkEl._askToolWired = true;
      linkEl.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        if (window.OporaWire && typeof window.OporaWire.handoffTo === 'function') {
          e.preventDefault();
          window.OporaWire.handoffTo(slug, payload || {}, {
            source_tool: 'ask-opora',
            wire_id: 'A1'
          });
        }
      });
    }

    function billSpecFromCompilerState(meta) {
      var cs = meta && meta.compiler_state;
      var fin = cs && cs.financial_engine;
      if (!fin) return null;
      var base = Number(fin.base_hourly_wage);
      var loaded = Number(fin.fully_burdened_hourly_cost);
      var bill = Number(fin.required_bill_rate_hourly);
      var margin = Number(fin.target_gross_margin_percent);
      var burdenPct = Number(fin.statutory_burden_percent);
      if (!(base > 0) || !(loaded > 0) || !(bill > 0) || !(margin > 0)) return null;
      var naiveMarkup = fin.flat_markup_comparison && Number(fin.flat_markup_comparison.flat_markup_rate);
      if (!(naiveMarkup > 0)) naiveMarkup = Math.round(loaded * (1 + margin / 100) * 100) / 100;
      var underbill = fin.flat_markup_comparison && Number(fin.flat_markup_comparison.hourly_margin_leakage);
      if (!(underbill >= 0)) underbill = Math.round((bill - naiveMarkup) * 100) / 100;
      return {
        base: base,
        loaded: loaded,
        bill: bill,
        margin: margin,
        burdenPct: burdenPct > 0 ? burdenPct : Math.round(((loaded / base) - 1) * 1000) / 10,
        burdenAmt: Math.round((loaded - base) * 100) / 100,
        naiveMarkup: naiveMarkup,
        underbill: underbill,
        contradiction: null,
        fromCompiler: true
      };
    }

    function injectAskUtility(turn, question, answer, meta) {
      if (!turn) return;
      clearAskUtility(turn);
      turn.classList.add('is-answered');

      var stateCode = detectAskState(question, answer, meta);
      if (meta && meta.compiler_state && meta.compiler_state.state_code) {
        stateCode = String(meta.compiler_state.state_code).toUpperCase();
      }
      if (meta && meta.engine_result && meta.engine_result.detectedStates && meta.engine_result.detectedStates[0]) {
        stateCode = String(meta.engine_result.detectedStates[0]).toUpperCase();
      }
      var facilityType = detectFacilityType(question, answer);
      var building = detectBuildingLabel(question, answer);

      /* Engine payload — ALWAYS mount scaffolding + CTAs when mountScaffold (no null dropout). */
      if (shouldMountEngineScaffold(meta)) {
        var engRows = engineRowsFromMeta(meta);
        turn._askFinRows = engRows;
        mountFinancialTableInFindings(
          turn,
          buildFinancialBreakdownHtml(engRows, {
            footnote: engineFootnoteFromMeta(meta) || DEDUCTION_SCAFFOLD_FOOTNOTE
          }),
          { beforeKeyFindings: true }
        );
        mountAskMathChips(turn, meta);
        if (!mountEngineCtas(turn, meta, stateCode)) {
          mountRegulatoryFallbackCtas(turn, stateCode, question, answer);
        }
        /* Keep sources rail populated from meta citations (caller already painted). */
        return;
      }

      /* Owner economics: same Financial Scaffolding shell, solo capacity schema + CTA */
      if (isOwnerEconomicsAsk(question, answer, meta)) {
        var detectedStates =
          (meta && Array.isArray(meta.detected_states) && meta.detected_states.length)
            ? meta.detected_states
            : (stateCode ? [stateCode] : []);
        var soloRows = buildSoloOperatorScaffoldingRows(detectedStates);
        turn._askFinRows = soloRows;
        mountFinancialTableInFindings(
          turn,
          buildFinancialBreakdownHtml(soloRows, { footnote: SOLO_SCAFFOLD_FOOTNOTE }),
          { beforeKeyFindings: true }
        );
        var soloState = stateCode || detectedStates[0] || 'CA';
        var bidSolo = withPreviewParam('/pages/bid-drafter?from=ask-opora&mode=solo&state=' + encodeURIComponent(soloState));
        var checklistSolo = buildLicensingUrl(soloState);
        var prettySolo = statePrettyName(soloState) || soloState;
        var rowSolo = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(bidSolo) + '">Model Solo Capacity in Bid Drafter \u2192</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(checklistSolo) + '">' +
            escapeHtml(prettySolo) + ' Compliance Checklist \u2192</a>'
        );
        wireToolHandoff(rowSolo.querySelector('.ask-handoff-primary'), 'bid-drafter', {
          source_tool: 'ask-opora',
          mode: 'solo',
          state: soloState
        });
        hideAskExternalHandoff();
        return;
      }

      /* Payroll deduction / uniform / PPE — Financial Scaffolding before Bid Drafter short-circuit */
      if (isPayrollDeductionAsk(question, meta)) {
        var dedRows =
          (meta && meta.compiler_state && Array.isArray(meta.compiler_state.financial_breakdown) && meta.compiler_state.financial_breakdown.length)
            ? meta.compiler_state.financial_breakdown
            : buildPayrollDeductionScaffoldingRows(question);
        turn._askFinRows = dedRows;
        mountFinancialTableInFindings(
          turn,
          buildFinancialBreakdownHtml(dedRows, { footnote: DEDUCTION_SCAFFOLD_FOOTNOTE }),
          { beforeKeyFindings: true }
        );
        var dedState = stateCode || 'WA';
        if (/\bseattle\b/i.test(String(question || ''))) dedState = 'WA';
        var hireDed = withPreviewParam('/pages/hire-right?from=ask-opora&state=' + encodeURIComponent(dedState) + '&mode=no-deduction');
        var checklistDed = buildLicensingUrl(dedState);
        var prettyDed = statePrettyName(dedState) || dedState;
        var rowDed = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(hireDed) + '">Draft compliant job post \u2192 Hire Right</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(checklistDed) + '">' +
            escapeHtml(prettyDed) + ' Compliance Checklist \u2192</a>'
        );
        wireToolHandoff(rowDed.querySelector('.ask-handoff-primary'), 'hire-right', {
          source_tool: 'ask-opora',
          state: dedState,
          mode: 'no-deduction'
        });
        hideAskExternalHandoff();
        return;
      }

      /*
       * Wage / under-the-table FIRST — always mount Financial Scaffolding + keep sources rail.
       * Must run before hasFinancialHook / Bid Drafter short-circuit (that was dropping the table).
       */
      var offBooks = isOffTheBooksAsk(question);
      var wageRelated = isWageAsk(question, answer, meta) || offBooks;
      var wage = wageRelated ? extractStatedWagePreferQuestion(question, answer) : null;
      /* Never scaffold commercial asks off arbitrary sub-$10 floors ($8 hallucinations). */
      if (wageRelated && wage && !offBooks) {
        var wageProbe = parseFloat(wage, 10);
        if (wageProbe > 0 && wageProbe < 10) {
          wage = null;
        }
      }
      if (wageRelated && wage) {
        var wageRows = offBooks
          ? buildOffBooksComplianceRows(wage, stateCode)
          : null;
        if (!wageRows) {
          var wageSpecEarly = buildWageBurdenSpec(wage, { burdenPct: 22.4 });
          if (wageSpecEarly) {
            var baseDetail = isMarketSalaryAsk(question)
              ? 'BLS OEWS median (SOC 37-2011)'
              : 'Stated input wage';
            wageRows = [
              { component: 'Base Direct Wage', detail: baseDetail, rate: formatAskMoney(wageSpecEarly.base) + '/hr' },
              {
                component: 'Statutory Burden (~' + wageSpecEarly.burdenPct + '%)',
                detail: burdenBreakdownLabel(stateCode, wageSpecEarly.burdenPct),
                rate: '+' + formatAskMoney(wageSpecEarly.burdenAmt) + '/hr'
              },
              { component: 'Fully Burdened Cost', detail: 'Direct labor break-even cost', rate: formatAskMoney(wageSpecEarly.loaded) + '/hr' },
              {
                component: 'Defensible Bill Rate (25% Divisor)',
                detail: formatAskMoney(wageSpecEarly.loaded) + ' / (1 \u2212 ' + (wageSpecEarly.margin / 100).toFixed(2) + ')',
                rate: formatAskMoney(wageSpecEarly.bill) + '/hr',
                highlight: true
              },
              {
                component: 'Markup Leakage Warning',
                detail: wageSpecEarly.margin + '% flat markup yields ' + formatAskMoney(wageSpecEarly.naiveMarkup) + '/hr',
                rate: '\u2212' + formatAskMoney(wageSpecEarly.underbill) + '/hr',
                warning: true
              }
            ];
          }
        }
        if (wageRows && wageRows.length) {
          turn._askFinRows = wageRows;
          var wageFoot = offBooks
            ? OFF_BOOKS_SCAFFOLD_FOOTNOTE
            : wageScaffoldFootnote(question, answer, stateCode, wage);
          mountFinancialTableInFindings(
            turn,
            buildFinancialBreakdownHtml(
              wageRows,
              wageFoot ? { footnote: wageFoot } : null
            ),
            { beforeKeyFindings: true }
          );
        }
        var wageNum = parseFloat(wage, 10);
        var calcUrl = buildBillRateCalcUrl(wage, stateCode);
        var hireUrl = buildHireRightUrl(wage, stateCode);
        var primaryHtml;
        var primaryTool;
        var primaryPayload;
        var clientIntent = classifyClientAskIntent(question);
        if (offBooks || (wageNum > 0 && wageNum < 10)) {
          primaryHtml =
            '<a class="ask-handoff-primary" href="' + escapeHtml(calcUrl) + '">' +
              'Calculate compliant rate (' + formatAskMoney(wageNum) + '/hr base) \u2192 Bill Rate Calculator</a>';
          primaryTool = 'bill-rate-calculator';
          primaryPayload = {
            source_tool: 'ask-opora',
            mode: 'compliant',
            base_wage: wage,
            wage: wage,
            state: stateCode || undefined
          };
        } else if (clientIntent === 'WAGE_RATE' || clientIntent === 'STATUTORY_BURDEN') {
          var billSpecCta = buildWageBurdenSpec(wage, { burdenPct: 22.4 });
          var billHint = billSpecCta ? formatAskMoney(billSpecCta.bill) : formatAskMoney(wageNum);
          primaryHtml =
            '<a class="ask-handoff-primary" href="' + escapeHtml(buildBidDrafterUrl({ bill: billSpecCta && billSpecCta.bill, base: wageNum }, stateCode, facilityType, building)) + '">' +
              'Draft proposal with ' + billHint + '/hr \u2192 Bid Drafter</a>';
          primaryTool = 'bid-drafter';
          primaryPayload = {
            source_tool: 'ask-opora',
            base_wage: wage,
            wage: wage,
            state: stateCode || undefined
          };
        } else {
          primaryHtml =
            '<a class="ask-handoff-primary" href="' + escapeHtml(hireUrl) + '">' +
              'Build job description with ' + formatAskMoney(wageNum) + '/hr \u2192 Hire Right</a>';
          primaryTool = 'hire-right';
          primaryPayload = {
            source_tool: 'ask-opora',
            base_wage: wage,
            wage: wage,
            wage_rate: wage,
            hourly_rate: wage,
            hourlyRate: wage,
            target_wage: wage,
            state: stateCode || undefined
          };
        }
        /* Intent-driven: exactly one primary CTA — no duplicate Bill Rate / Hire pills. */
        var row2 = insertAskHandoffRow(turn, primaryHtml);
        wireToolHandoff(row2.querySelector('.ask-handoff-primary'), primaryTool, primaryPayload);
        hideAskExternalHandoff();
        return;
      }

      /* Sqft facility benchmarks without engine payload — soft handoff only (no hourly scaffold). */
      if (isSqftBenchmarkAsk(question) || (meta && meta.intent === 'SQFT_BENCHMARK')) {
        var sqftCalc = withPreviewParam('/pages/bill-rate-calculator?from=ask-opora&sqft=40000' +
          (stateCode ? '&state=' + encodeURIComponent(stateCode) : ''));
        var rowSqft = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(sqftCalc) + '">Model Facility in Bill Rate Calculator \u2192</a>'
        );
        wireToolHandoff(rowSqft.querySelector('.ask-handoff-primary'), 'bill-rate-calculator', {
          source_tool: 'ask-opora',
          state: stateCode || undefined,
          sqft: 40000
        });
        hideAskExternalHandoff();
        return;
      }

      if (classifyClientAskIntent(question) === 'DRAFTING_REQUEST') {
        var draftUrl = withPreviewParam('/pages/bid-drafter?from=ask-opora&prefill=' + encodeURIComponent(String(question || '').slice(0, 500)) +
          (stateCode ? '&state=' + encodeURIComponent(stateCode) : ''));
        var rowDraft = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(draftUrl) + '">Launch Bid Drafter with these specs \u2192</a>'
        );
        wireToolHandoff(rowDraft.querySelector('.ask-handoff-primary'), 'bid-drafter', {
          source_tool: 'ask-opora',
          state: stateCode || undefined
        });
        hideAskExternalHandoff();
        return;
      }

      var compilerState = meta && meta.compiler_state;
      var breakdownRows = compilerState && Array.isArray(compilerState.financial_breakdown)
        ? compilerState.financial_breakdown
        : null;
      if ((!breakdownRows || !breakdownRows.length) && turn._askFinRows && turn._askFinRows.length) {
        breakdownRows = turn._askFinRows;
      }
      var billSpec = billSpecFromCompilerState(meta) ||
        parseBillRateSpec(question, answer) ||
        billSpecFromAnswerText(question, answer);

      /* Force exactly one table from compiler breakdown (preferred) or billSpec */
      if (breakdownRows && breakdownRows.length) {
        mountFinancialTableInFindings(turn, buildFinancialBreakdownHtml(breakdownRows));
      } else if (billSpec) {
        mountFinancialTableInFindings(turn, buildBillRateMathHtml(billSpec, stateCode));
      } else {
        upgradeSmashedPipeTables(turn.querySelector('.ask-a-body'), null);
      }

      var hasFinancialHook = !!(
        (breakdownRows && breakdownRows.length) ||
        (compilerState && compilerState.downstream_payload && compilerState.downstream_payload.serialized_query_string) ||
        parseOporaCtaMarker(answer) ||
        (billSpec && billSpec.bill > 0)
      );
      if (hasFinancialHook) {
        mountBidDrafterCta(turn, billSpec, compilerState, stateCode, facilityType, building, answer);
        return;
      }

      /* Margin / bill-rate ask without a parseable base wage (e.g. Columbus sf pricing) */
      if (isBillRateAsk(question, answer)) {
        var marginOnly = extractMarginPct(question) || extractMarginPct(answer) || 20;
        var softSpec = { bill: 0, base: 0, loaded: 0, margin: marginOnly };
        var softParams = new URLSearchParams();
        softParams.set('from', 'ask-opora');
        softParams.set('target_margin', String(marginOnly));
        if (stateCode) softParams.set('state', stateCode);
        try {
          var softPrefill = {
            source_tool: 'ask-opora',
            target_margin: marginOnly
          };
          if (stateCode) softPrefill.state = stateCode;
          softParams.set('prefill', JSON.stringify(softPrefill));
        } catch (eSoft) {}
        var calcUrlSoft = withPreviewParam('/pages/bill-rate-calculator?' + softParams.toString());
        var bidUrlSoft = buildBidDrafterUrl(softSpec, stateCode, facilityType, building);
        var secondarySoft = buildSecondaryHandoff(stateCode, building);
        var rowSoft = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(calcUrlSoft) + '">Set burden + margin \u2192 Bill Rate Calculator</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(bidUrlSoft) + '">Draft proposal \u2192 Bid Drafter</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(secondarySoft.href) + '">' + escapeHtml(secondarySoft.label) + '</a>'
        );
        wireToolHandoff(rowSoft.querySelector('.ask-handoff-primary'), 'bill-rate-calculator', {
          source_tool: 'ask-opora',
          state: stateCode || undefined,
          target_margin: marginOnly
        });
        wireToolHandoff(rowSoft.querySelectorAll('.ask-handoff-secondary')[0], 'bid-drafter', {
          source_tool: 'ask-opora',
          gross_margin: marginOnly,
          state: stateCode || undefined,
          facility_type: facilityType || undefined,
          building: building || undefined
        });
        hideAskExternalHandoff();
        return;
      }

      if (isClientCommsAsk(question, answer)) {
        mountClientCommsCtas(turn, stateCode);
        return;
      }

      if (isBidPacketAsk(question)) {
        var bidUrlPkt = withPreviewParam(
          '/pages/bid-drafter?from=ask-opora' +
            (stateCode ? ('&state=' + encodeURIComponent(stateCode)) : '')
        );
        var rowBid = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(bidUrlPkt) + '">Open in Bid Drafter \u2192</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(buildLicensingUrl(stateCode || 'IL')) + '">' +
            escapeHtml(statePrettyName(stateCode || 'IL') || (stateCode || 'IL')) + ' Compliance Checklist \u2192</a>'
        );
        wireToolHandoff(rowBid.querySelector('.ask-handoff-primary'), 'bid-drafter', {
          source_tool: 'ask-opora',
          state: stateCode || undefined,
          intent: 'bid-packet'
        });
        hideAskExternalHandoff();
        return;
      }

      if (isHiringAsk(question, answer)) {
        mountRegulatoryFallbackCtas(turn, stateCode, question, answer);
        return;
      }

      if (isPricingCtaAsk(question, answer) && !turn.querySelector('.ask-handoff-primary')) {
        var calcUrlPx = withPreviewParam(
          '/pages/bill-rate-calculator?from=ask-opora' +
            (stateCode ? ('&state=' + encodeURIComponent(stateCode)) : '')
        );
        var rowPx = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(calcUrlPx) + '">Model margin impact \u2192 Bill Rate Calculator</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(buildLicensingUrl(stateCode || 'CA')) + '">' +
            escapeHtml(statePrettyName(stateCode || 'CA') || (stateCode || 'CA')) + ' Compliance Checklist \u2192</a>'
        );
        wireToolHandoff(rowPx.querySelector('.ask-handoff-primary'), 'bill-rate-calculator', {
          source_tool: 'ask-opora',
          state: stateCode || undefined,
          intent: 'pricing'
        });
        hideAskExternalHandoff();
        return;
      }

      if (!compilerState && !isBillRateAsk(question, answer) && isRfpAsk(question, answer)) {
        showAskExternalHandoff();
      } else {
        hideAskExternalHandoff();
      }

      if (
        !turn.querySelector('.ask-handoff-primary') &&
        !isBillRateAsk(question, answer) &&
        !isRfpAsk(question, answer) &&
        !isClientCommsAsk(question, answer) &&
        !isBidPacketAsk(question) &&
        !isSafetyComplianceAsk(question, answer)
      ) {
        mountRegulatoryFallbackCtas(turn, stateCode, question, answer);
      }
    }

    function buildLicensingUrl(stateCode) {
      var slug = stateCode && ASK_STATE_SLUGS[stateCode] ? ASK_STATE_SLUGS[stateCode] : null;
      if (!slug) return withPreviewParam('/pages/tools');
      return withPreviewParam('/pages/licensing-' + slug);
    }

    function mountClientCommsCtas(turn, stateCode) {
      if (!turn) return;
      var calcUrl = withPreviewParam(
        '/pages/bill-rate-calculator?from=ask-opora' +
          (stateCode ? ('&state=' + encodeURIComponent(stateCode)) : '')
      );
      var row = insertAskHandoffRow(turn,
        '<a class="ask-handoff-primary" href="' + escapeHtml(calcUrl) + '">Calculate margin impact \u2192 Bill Rate Calculator</a>' +
        '<button type="button" class="ask-handoff-secondary ask-copy-memo">Copy clean memo</button>'
      );
      wireToolHandoff(row.querySelector('.ask-handoff-primary'), 'bill-rate-calculator', {
        source_tool: 'ask-opora',
        state: stateCode || undefined,
        intent: 'price-letter'
      });
      var copyBtn = row.querySelector('.ask-copy-memo');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var body = turn.querySelector('.ask-a-body, .ask-a-main, .ask-a');
          var text = body ? String(body.innerText || body.textContent || '').trim() : '';
          if (!text) return;
          var done = function () {
            copyBtn.textContent = 'Copied \u2713';
            setTimeout(function () { copyBtn.textContent = 'Copy clean memo'; }, 1800);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done).catch(function () {
              try {
                var ta = document.createElement('textarea');
                ta.value = text;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                ta.remove();
                done();
              } catch (e) {}
            });
          }
        });
      }
      hideAskExternalHandoff();
    }

    function mountRegulatoryFallbackCtas(turn, stateCode, question, answer) {
      if (!turn) return;
      if (isClientCommsAsk(question, answer)) {
        mountClientCommsCtas(turn, stateCode);
        return;
      }
      if (isBidPacketAsk(question)) {
        var bidUrlFb = withPreviewParam(
          '/pages/bid-drafter?from=ask-opora' +
            (stateCode ? ('&state=' + encodeURIComponent(stateCode)) : '')
        );
        var rowFb = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(bidUrlFb) + '">Open in Bid Drafter \u2192</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(buildLicensingUrl(stateCode || 'CA')) + '">' +
            escapeHtml(statePrettyName(stateCode || 'CA') || (stateCode || 'CA')) + ' Compliance Checklist \u2192</a>'
        );
        wireToolHandoff(rowFb.querySelector('.ask-handoff-primary'), 'bid-drafter', {
          source_tool: 'ask-opora',
          state: stateCode || undefined,
          intent: 'bid-packet'
        });
        hideAskExternalHandoff();
        return;
      }
      var st = String(stateCode || detectAskState(question, answer, null) || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(st)) {
        /* No silent CA default when the question named another place — link tools hub instead. */
        st = '';
      }
      var pretty = st ? (statePrettyName(st) || st) : '';
      var checklistUrl = st ? buildLicensingUrl(st) : withPreviewParam('/pages/tools');
      var hireUrl = withPreviewParam(
        '/pages/hire-right?from=ask-opora' + (st ? ('&state=' + encodeURIComponent(st)) : '')
      );

      if (isHiringAsk(question, answer) || isWageAsk(question, answer, null)) {
        var rowHire = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(hireUrl) + '">Draft compliant job post \u2192 Hire Right</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(checklistUrl) + '">' +
            escapeHtml(pretty ? (pretty + ' Compliance Checklist') : 'Browse compliance tools') + ' \u2192</a>'
        );
        wireToolHandoff(rowHire.querySelector('.ask-handoff-primary'), 'hire-right', {
          source_tool: 'ask-opora',
          state: st || undefined
        });
        hideAskExternalHandoff();
        return;
      }

      if (isPricingCtaAsk(question, answer)) {
        var calcUrl = withPreviewParam(
          '/pages/bill-rate-calculator?from=ask-opora' + (st ? ('&state=' + encodeURIComponent(st)) : '')
        );
        var rowCalc = insertAskHandoffRow(turn,
          '<a class="ask-handoff-primary" href="' + escapeHtml(calcUrl) + '">Model margin impact \u2192 Bill Rate Calculator</a>' +
          '<a class="ask-handoff-secondary" href="' + escapeHtml(checklistUrl) + '">' +
            escapeHtml(pretty ? (pretty + ' Compliance Checklist') : 'Browse compliance tools') + ' \u2192</a>'
        );
        wireToolHandoff(rowCalc.querySelector('.ask-handoff-primary'), 'bill-rate-calculator', {
          source_tool: 'ask-opora',
          state: st || undefined
        });
        hideAskExternalHandoff();
        return;
      }

      /* True generic fallback: compliance checklist first — do not default to Hire Right */
      var toolsUrl = withPreviewParam('/pages/tools');
      var row = insertAskHandoffRow(turn,
        '<a class="ask-handoff-primary" href="' + escapeHtml(checklistUrl) + '">' +
          escapeHtml(pretty ? (pretty + ' Compliance Checklist') : 'Browse compliance tools') + ' \u2192</a>' +
        '<a class="ask-handoff-secondary" href="' + escapeHtml(toolsUrl) + '">Browse tools \u2192</a>'
      );
      hideAskExternalHandoff();
    }

    function finalize(bodyEl, railEl, auditTs, t0, turn, question, fullText, citations, meta) {
      var caret = bodyEl.querySelector('.stream-caret'); if (caret) caret.remove();
      var aligned = alignClientCitations(fullText, citations || []);
      fullText = aligned.answer;
      citations = aligned.citations;
      if (!fullText.trim() && !citations.length) {
        bodyEl.innerHTML = '<p>No answer came back for that one. Try rephrasing, or open a tool below.</p>';
        return;
      }
      var extracted = extractFinancialScaffolding(fullText);
      var paintText = extracted.cleanContent || fullText;
      bodyEl.innerHTML = textWithCites(paintText, citations);
      hydrateRawMarkdownLinks(bodyEl);
      stripOporaCtaMarkers(bodyEl);
      Array.prototype.slice.call(bodyEl.querySelectorAll('p, em, div, li')).forEach(function (el) {
        var t = el.textContent || '';
        if (/Financial stack loads as a structured table/i.test(t) || /OPORA_RATE_STACK/i.test(t)) {
          el.remove();
        }
      });
      var ownerEcon = isOwnerEconomicsAsk(question, fullText, meta);
      var deductionAsk = isPayrollDeductionAsk(question, meta);
      var offBooksEarly = isOffTheBooksAsk(question);
      var wageEarly = (offBooksEarly || isWageAsk(question, fullText, meta))
        ? extractStatedWagePreferQuestion(question, fullText)
        : null;
      var detectedEarly =
        (meta && meta.engine_result && Array.isArray(meta.engine_result.detectedStates) && meta.engine_result.detectedStates.length)
          ? meta.engine_result.detectedStates
          : ((meta && Array.isArray(meta.detected_states) && meta.detected_states.length)
            ? meta.detected_states
            : []);
      var earlyRows = null;
      if (shouldMountEngineScaffold(meta)) {
        earlyRows = engineRowsFromMeta(meta);
      } else if (ownerEcon) {
        earlyRows = buildSoloOperatorScaffoldingRows(detectedEarly);
      } else if (deductionAsk) {
        earlyRows = (meta && meta.compiler_state && Array.isArray(meta.compiler_state.financial_breakdown) && meta.compiler_state.financial_breakdown.length)
          ? meta.compiler_state.financial_breakdown
          : buildPayrollDeductionScaffoldingRows(question);
      } else if (offBooksEarly && wageEarly) {
        earlyRows = buildOffBooksComplianceRows(wageEarly, (meta && meta.geo_state) || detectedEarly[0] || 'PA');
      } else if (wageEarly && isMarketSalaryAsk(question)) {
        var stWageEarly = detectAskState(question, fullText, meta) || (detectedEarly[0] || null);
        var specWageEarly = buildWageBurdenSpec(wageEarly, { burdenPct: 22.4 });
        if (specWageEarly) {
          earlyRows = [
            { component: 'Base Direct Wage', detail: 'BLS OEWS median (SOC 37-2011)', rate: formatAskMoney(specWageEarly.base) + '/hr' },
            {
              component: 'Statutory Burden (~' + specWageEarly.burdenPct + '%)',
              detail: burdenBreakdownLabel(stWageEarly, specWageEarly.burdenPct),
              rate: '+' + formatAskMoney(specWageEarly.burdenAmt) + '/hr'
            },
            { component: 'Fully Burdened Cost', detail: 'Direct labor break-even cost', rate: formatAskMoney(specWageEarly.loaded) + '/hr' },
            {
              component: 'Defensible Bill Rate (25% Divisor)',
              detail: formatAskMoney(specWageEarly.loaded) + ' / (1 \u2212 0.25)',
              rate: formatAskMoney(specWageEarly.bill) + '/hr',
              highlight: true
            },
            {
              component: 'Markup Leakage Warning',
              detail: specWageEarly.margin + '% flat markup yields ' + formatAskMoney(specWageEarly.naiveMarkup) + '/hr',
              rate: '\u2212' + formatAskMoney(specWageEarly.underbill) + '/hr',
              warning: true
            }
          ];
          turn && (turn._askWageFootnote = wageScaffoldFootnote(question, fullText, stWageEarly, wageEarly));
        }
      } else if (meta && meta.compiler_state && Array.isArray(meta.compiler_state.financial_breakdown) && meta.compiler_state.financial_breakdown.length) {
        earlyRows = meta.compiler_state.financial_breakdown;
      } else {
        earlyRows = extracted.tableRows || null;
      }
      if (turn) {
        turn._askFinRows = earlyRows || null;
      }
      /* Mount the flex table immediately after paint — do not wait for later inject hooks */
      if (turn && earlyRows && earlyRows.length) {
        try {
          var footEarly = null;
          if (shouldMountEngineScaffold(meta)) {
            footEarly = { footnote: engineFootnoteFromMeta(meta) || '' };
          } else if (ownerEcon) {
            footEarly = { footnote: SOLO_SCAFFOLD_FOOTNOTE };
          } else if (deductionAsk) {
            footEarly = { footnote: DEDUCTION_SCAFFOLD_FOOTNOTE };
          } else if (offBooksEarly) {
            footEarly = { footnote: OFF_BOOKS_SCAFFOLD_FOOTNOTE };
          } else if (turn._askWageFootnote) {
            footEarly = { footnote: turn._askWageFootnote };
          }
          mountFinancialTableInFindings(
            turn,
            buildFinancialBreakdownHtml(earlyRows, footEarly),
            (shouldMountEngineScaffold(meta) || ownerEcon || deductionAsk || offBooksEarly || turn._askWageFootnote)
              ? { beforeKeyFindings: true }
              : null
          );
        } catch (errEarly) {
          try { console.warn('[AskOpora] early fin mount failed', errEarly); } catch (eE) {}
        }
      }
      /* Skip upgradeSmashedPipeTables here — injectAskUtility mounts the single table. */
      var geo = formatVerifiedSourcesGeoLabel(meta, question);
      var clarifyOnly = isClarifyOrRefusalAnswer(fullText, meta);
      if (clarifyOnly) {
        updateRail(railEl, [], '');
      } else {
        updateRail(railEl, citations, geo);
      }
      var elapsed = ((Date.now() - t0) / 1000).toFixed(1) + 's';
      if (auditTs) {
        var srcCount = (!clarifyOnly && citations.length) ? ' \u00b7 ' + citations.length + ' source' + (citations.length === 1 ? '' : 's') : '';
        auditTs.textContent = clarifyOnly ? (elapsed + ' \u00b7 needs state') : (elapsed + srcCount);
      }
      if (turn) {
        turn._askState = { question: question, answer: fullText, citations: clarifyOnly ? [] : citations, meta: meta || {} };
        try { paintAskShellSources(collectThreadCitations()); } catch (eSrc) {}
        var badge = turn.querySelector('.ask-audit-route');
        var expand = turn.querySelector('.ask-audit-expand');
        var panel = turn.querySelector('.ask-audit-panel');
        var saveBtn = turn.querySelector('.ask-save-btn');
        var exp = explainRouting(meta && meta.routing);
        if (badge && !clarifyOnly) {
          badge.textContent = exp.badge;
          badge.hidden = false;
        }
        if (expand && panel && !clarifyOnly) {
          expand.hidden = false;
          panel.innerHTML = buildAuditPanel(meta, question, citations, elapsed);
          panel.hidden = true;
          expand.setAttribute('aria-expanded', 'false');
        }
        if (saveBtn && fullText.trim() && !clarifyOnly) {
          saveBtn.hidden = false;
        }
        var copyMdShow = turn.querySelector('.ask-copy-md');
        if (copyMdShow && fullText.trim() && !clarifyOnly) copyMdShow.hidden = false;
        var sep = turn.querySelector('.ask-audit-sep');
        if (sep) sep.hidden = !(badge && !badge.hidden);
        if (clarifyOnly) {
          suppressClarifyChrome(turn);
          try { markActiveAskTurn(turn); } catch (eCl) {}
          return;
        }
        try {
          injectAskUtility(turn, question, fullText, meta);
        } catch (err) {
          try { console.warn('[AskOpora] injectAskUtility failed', err); } catch (e0) {}
        }
        try {
          packEstimateBand(turn);
        } catch (errPack) {}
        /* Always restore Verified Sources rail in the two-column split (never leave it packed away) */
        try {
          ensureSourcesRail(turn, citations, geo);
        } catch (errRail) {}
        try {
          packScaffoldSourcesBand(turn);
          ensureSourcesRail(turn, citations, geo);
        } catch (errBand) {}
        /* Owner economics: keep solo scaffold; never smash/force W-2 $bill CTAs */
        if (!ownerEcon && !offBooksEarly) {
          try {
            smashPlainFinancialScaffoldInDom(turn, meta);
          } catch (err3) {}
          try {
            if (!turn.querySelector('.ask-handoff-primary')) {
              var cs2 = meta && meta.compiler_state;
              var spec2 = billSpecFromCompilerState(meta) || billSpecFromAnswerText(question, fullText);
              if ((cs2 && cs2.financial_breakdown && cs2.financial_breakdown.length) || (spec2 && spec2.bill > 0) || parseOporaCtaMarker(fullText)) {
                mountBidDrafterCta(
                  turn,
                  spec2,
                  cs2,
                  (cs2 && cs2.state_code) || detectAskState(question, fullText, meta),
                  detectFacilityType(question, fullText),
                  detectBuildingLabel(question, fullText),
                  fullText
                );
              }
            }
          } catch (err2) {
            try { console.warn('[AskOpora] CTA fallback failed', err2); } catch (e1) {}
          }
        }
        try { markActiveAskTurn(turn); } catch (eActive) {}
      }
    }

    function smashPlainFinancialScaffoldInDom(turn, meta) {
      if (!turn) return;
      var body = turn.querySelector('.ask-a-body');
      if (!body) return;
      var hasGrid = !!body.querySelector('[data-ask-fin-once] .ask-fin-stack, [data-ask-fin-once] .ask-fin-grid, [data-ask-fin-once] table.ask-fin-table');
      /* Always strip leftover space-padded plaintext even when a grid already exists */
      Array.prototype.slice.call(body.querySelectorAll('p, pre, div')).forEach(function (el) {
        if (el.closest && el.closest('[data-ask-fin-once]')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (isAsciiFinancialScaffoldText(t) || (/Financial scaffolding/i.test(t) && /Base Direct/i.test(t))) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      });
      if (hasGrid && body.querySelector('[data-ask-fin-once]')) return;
      var blob = body.textContent || '';
      if (!/Financial scaffolding/i.test(blob) && !(/Metric/.test(blob) && /Base Direct/i.test(blob)) &&
          !(meta && meta.compiler_state && meta.compiler_state.financial_breakdown && meta.compiler_state.financial_breakdown.length)) {
        return;
      }
      var rows = (turn._askFinRows && turn._askFinRows.length)
        ? turn._askFinRows
        : (meta && meta.compiler_state && meta.compiler_state.financial_breakdown) || null;
      if (!rows || !rows.length) {
        var parsed = extractFinancialScaffolding(blob);
        rows = parsed.tableRows;
      }
      if (!rows || !rows.length) return;
      mountFinancialTableInFindings(turn, buildFinancialBreakdownHtml(rows));
    }

    function scrollIfNeeded() {
      if (!thread) return;
      var last = thread.querySelector('.ask-turn:last-child');
      try {
        if (last && typeof last.scrollIntoView === 'function') {
          last.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          thread.scrollTop = thread.scrollHeight;
        }
      } catch (e) {
        try { thread.scrollTop = thread.scrollHeight; } catch (e2) {}
      }
    }

    function hostOf(url) { try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }

    /* Replace [n] markers with hoverable citation chips */
    function textWithCites(text, citations) {
      var html = renderMarkdown(text);
      html = html.replace(/\[(\d{1,2})\]/g, function (full, n) {
        var idx = parseInt(n, 10) - 1;
        var c = citations[idx];
        var tip = '';
        if (c) {
          tip = '<span class="cite-tip">' +
            (c.domain ? '<span class="cite-tip-domain">' + escapeHtml(c.domain) + '</span>' : '') +
            '<span class="cite-tip-title">' + escapeHtml(c.detail || c.name) + '</span></span>';
        }
        return '<button type="button" class="cite-chip" data-cite="' + n + '"' +
          (c && c.url ? ' data-url="' + escapeHtml(c.url) + '"' : '') +
          ' aria-label="Open source ' + n + '">[' + n + ']' + tip + '</button>';
      });
      return html;
    }

    function buildSources(citations) {
      var wrap = document.createElement('div');
      wrap.className = 'ask-sources';
      var chips = citations.map(function (c, i) {
        return '<span class="src-chip" title="' + escapeHtml(c.detail || c.name) + '">' +
          '<span class="src-num">' + (i + 1) + '</span>' +
          '<span class="src-name">' + escapeHtml(c.name) + '</span></span>';
      }).join('');
      wrap.innerHTML = '<div class="ask-sources-label">Sources · ' + citations.length + '</div>' +
        '<div class="ask-sources-grid">' + chips + '</div>';
      return wrap;
    }
  })();

  /* ════════════════════════════════════════════════════════════
     8 OTHER TOOLS — expand/collapse + run
  ════════════════════════════════════════════════════════════ */

  // expand / collapse — single delegated listener on document so it is
  // immune to ordering (works even if .tool nodes are added/replaced later),
  // and resilient to any earlier-running script that may otherwise clobber
  // per-element listeners in the deployed iframe. (Root cause of the
  // "cards won't expand" report.)
  document.addEventListener('click', function (e) {
    var head = e.target.closest && e.target.closest('.tool-head');
    if (!head) return;
    var tool = head.closest('.tool');
    if (!tool) return;
    var panel = tool.querySelector('.tool-panel');
    if (!panel) return;
    var willOpen = !tool.classList.contains('is-open');
    head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) {
      // 1) take it out of display:none, 2) force a reflow at max-height:0,
      // 3) add .is-open so max-height animates from 0 → open. CSS does the rest.
      panel.hidden = false;
      void panel.offsetHeight; // reflow
      tool.classList.add('is-open');
    } else {
      // collapse now (animates back to 0); remove from layout after transition
      tool.classList.remove('is-open');
      var done = false;
      var hide = function () {
        if (done) return; done = true;
        if (!tool.classList.contains('is-open')) panel.hidden = true;
      };
      panel.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 360);
    }
  });

  /* Payload builders per tool — map form fields → worker request shape */
  var PAYLOAD = {
    bid_drafter: function (f) {
      var freq = f.frequency.value;
      return {
        tone: 'professional',
        deal_details: {
          building_type: f.building_type.value,
          vertical: 'commercial',
          sqft: numOr(f.sqft.value, 0),
          floors: numOr(f.floors.value, 1),
          frequency: freq,
          city: clamp(f.city.value, 60) || 'Houston',
          state: clamp(f.state.value, 2).toUpperCase() || 'TX',
          metro: clamp(f.city.value, 60) || 'Houston',
          prevailing_wage_applicable: !!f.prevailing_wage.checked
        },
        business_profile: buildBusinessProfile(f.business.value, { prevailing_wage_applicable: !!f.prevailing_wage.checked })
      };
    },
    rfp_decode: function (f) { return { rfp_text: f.rfp_text.value }; },
    lost_bid_autopsy: function (f) {
      var p = { bid_text: clamp(f.bid_text.value, 20000), loss_feedback: clamp(f.loss_feedback.value, 4000) };
      if (f.winner_price.value) p.winner_price = numOr(f.winner_price.value, 0);
      return p;
    },
    customer_recovery: function (f) {
      return {
        lost_account_name: clamp(f.lost_account_name.value, 120),
        reason_lost: f.reason_lost.value,
        months_since: numOr(f.months_since.value, 0),
        business_profile: buildBusinessProfile(f.business.value)
      };
    },
    margin_sentinel: function (f) {
      return {
        bid_price_total: numOr(f.bid_price_total.value, 0),
        estimated_labor: numOr(f.labor.value, 0),
        estimated_supplies: numOr(f.supplies.value, 0),
        estimated_equipment: numOr(f.equipment.value, 0),
        estimated_overhead: numOr(f.overhead.value, 0),
        labor: numOr(f.labor.value, 0),
        supplies: numOr(f.supplies.value, 0),
        equipment: numOr(f.equipment.value, 0),
        overhead: numOr(f.overhead.value, 0)
      };
    },
    compliance_check: function (f) {
      var states = parseStates(f.states.value);
      return {
        states: states,
        state: states[0] || 'TX',
        business_size: f.business_size.value,
        employee_count: numOr(f.employee_count.value, 12),
        workforce_type: f.workforce_type.value,
        vertical: 'commercial cleaning',
        services_offered: ['janitorial', 'floor care', 'disinfection'],
        business_profile: buildBusinessProfile(f.business.value)
      };
    },
    handbook_draft: function (f) {
      var langs = ['en']; if (f.lang_es && f.lang_es.checked) langs.push('es');
      var states = parseStates(f.states.value);
      return {
        states: states,
        languages: langs,
        business_profile: buildBusinessProfile(f.business.value)
      };
    },
    hire_right: function (f) {
      return {
        role: f.role.value,
        state: clamp(f.state.value, 2).toUpperCase() || 'TX',
        tone: 'professional',
        business_profile: buildBusinessProfile(f.business.value)
      };
    }
  };

  /* Client-side required-field validation per tool */
  var VALIDATE = {
    bid_drafter: function (f) { var e = {}; if (!f.sqft.value || numOr(f.sqft.value, 0) < 100) e.sqft = 'Enter square footage (100+).'; if (!/^[A-Za-z]{2}$/.test(f.state.value.trim())) e.state = 'Use a 2-letter state code.'; if (f.business.value.trim().length < 8) e.business = 'Add a short business description.'; return e; },
    rfp_decode: function (f, opts) { var e = {}; if (!(opts && opts.fromFile) && f.rfp_text.value.trim().length < 40) e.rfp_text = 'Paste the RFP text (or upload a PDF).'; return e; },
    lost_bid_autopsy: function (f) { var e = {}; if (f.bid_text.value.trim().length < 20) e.bid_text = 'Paste the bid you submitted.'; return e; },
    customer_recovery: function (f) { var e = {}; if (f.lost_account_name.value.trim().length < 2) e.lost_account_name = 'Name the lost account.'; if (f.business.value.trim().length < 8) e.business = 'Add a short business description.'; return e; },
    margin_sentinel: function (f) { var e = {}; if (!f.bid_price_total.value || numOr(f.bid_price_total.value, 0) <= 0) e.bid_price_total = 'Enter the total bid price.'; return e; },
    compliance_check: function (f) { var e = {}; if (parseStates(f.states.value).length === 0) e.states = 'Enter at least one state (e.g. TX).'; if (!f.employee_count.value || numOr(f.employee_count.value, 0) < 1) e.employee_count = 'Enter employee count.'; if (f.business.value.trim().length < 8) e.business = 'Add a short business description.'; return e; },
    handbook_draft: function (f) { var e = {}; if (parseStates(f.states.value).length === 0) e.states = 'Enter at least one state.'; if (f.business.value.trim().length < 8) e.business = 'Add a short business description.'; return e; },
    hire_right: function (f) { var e = {}; if (!/^[A-Za-z]{2}$/.test(f.state.value.trim())) e.state = 'Use a 2-letter state code.'; if (f.business.value.trim().length < 8) e.business = 'Add a short business description.'; return e; }
  };

  function numOr(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function parseStates(v) { return clamp(v, 120).split(/[,;/]+/).map(function (s) { return s.trim().toUpperCase(); }).filter(function (s) { return /^[A-Z]{2}$/.test(s); }); }

  // wire up each tool form
  document.querySelectorAll('.tool').forEach(function (tool) {
    var key = tool.dataset.tool;
    var endpoint = tool.dataset.endpoint;
    var form = tool.querySelector('.tool-form');
    var resultEl = tool.querySelector('.tool-result');
    if (!form || !resultEl) return;
    var cookieKey = 'opora_demo_' + key;

    // RFP file upload handling
    var fileInput = form.querySelector('.upload-input');
    var fileNameEl = form.querySelector('.upload-name');
    var pickedFile = null;
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        pickedFile = null;
        if (!file) { fileNameEl.textContent = ''; fileNameEl.classList.remove('is-error'); return; }
        if (file.type !== 'application/pdf') { fileNameEl.textContent = 'PDF files only.'; fileNameEl.classList.add('is-error'); fileInput.value = ''; return; }
        if (file.size > 10 * 1024 * 1024) { fileNameEl.textContent = 'File exceeds 10 MB.'; fileNameEl.classList.add('is-error'); fileInput.value = ''; return; }
        pickedFile = file; fileNameEl.classList.remove('is-error'); fileNameEl.textContent = file.name;
      });
    }

    // clear field errors on input
    form.addEventListener('input', function (e) {
      var name = e.target.name;
      var errEl = form.querySelector('[data-err="' + name + '"]');
      if (errEl) errEl.textContent = '';
      e.target.classList.remove('invalid');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // gate check
      if (!isUnlimited() && cookies.get(cookieKey) >= TOOL_FREE_LIMIT) { openGate(); return; }

      // RFP PDF path: extract text first, then validate/run
      if (key === 'rfp_decode' && pickedFile) {
        runRfpFromPdf();
        return;
      }

      // Named access (form.fieldName) works directly on the <form> element
      var errors = (VALIDATE[key] || function () { return {}; })(form, {});
      if (showErrors(errors)) return;

      var payload = PAYLOAD[key](form);
      execute(payload);
    });

    function runRfpFromPdf() {
      var btn = form.querySelector('.tool-run');
      showSkeleton('Extracting text from your PDF…');
      btn.classList.add('is-loading'); btn.disabled = true;
      var fd = new FormData();
      fd.append('file', pickedFile);
      fetch(API_BASE + '/api/rfp-decode/extract-text', { method: 'POST', body: fd })
        .then(function (res) {
          return res.text().then(function (t) {
            if (!res.ok) { var msg = ''; try { msg = JSON.parse(t).error; } catch (e) {} var err = new Error(msg); err.status = res.status; throw err; }
            var j; try { j = JSON.parse(t); } catch (e) { j = { text: t }; }
            return j.text || j.rfp_text || j.extracted_text || '';
          });
        })
        .then(function (text) {
          if (!text || text.trim().length < 20) { throw Object.assign(new Error('Could not read text from that PDF.'), { status: 400 }); }
          var ta = form.querySelector('[name="rfp_text"]'); if (ta) ta.value = text;
          showSkeleton('Decoding the RFP…');
          return postJson(endpoint, { rfp_text: text });
        })
        .then(function (data) { btn.classList.remove('is-loading'); btn.disabled = false; commitRun(cookieKey); renderResult(data); })
        .catch(function (err) { btn.classList.remove('is-loading'); btn.disabled = false; renderError(err); });
    }

    function execute(payload) {
      var btn = form.querySelector('.tool-run');
      showSkeleton();
      btn.classList.add('is-loading'); btn.disabled = true;
      var t0 = performance.now();
      postJson(endpoint, payload)
        .then(function (data) {
          btn.classList.remove('is-loading'); btn.disabled = false;
          commitRun(cookieKey);
          renderResult(data, Math.round(performance.now() - t0));
        })
        .catch(function (err) {
          btn.classList.remove('is-loading'); btn.disabled = false;
          renderError(err);
        });
    }

    function commitRun(ck) { cookies.set(ck, cookies.get(ck) + 1); }

    function showErrors(errors) {
      // clear
      form.querySelectorAll('.field-err').forEach(function (el) { el.textContent = ''; });
      form.querySelectorAll('.invalid').forEach(function (el) { el.classList.remove('invalid'); });
      var has = false, firstField = null;
      Object.keys(errors).forEach(function (name) {
        has = true;
        var errEl = form.querySelector('[data-err="' + name + '"]');
        if (errEl) errEl.textContent = errors[name];
        var fld = form.querySelector('[name="' + name + '"]');
        if (fld) { fld.classList.add('invalid'); if (!firstField) firstField = fld; }
      });
      if (firstField) firstField.focus();
      return has;
    }

    function showSkeleton(label) {
      resultEl.hidden = false;
      resultEl.innerHTML =
        '<div class="result-head"><span class="result-dot" aria-hidden="true"></span><h4>Working</h4></div>' +
        '<div class="skeleton" role="status" aria-live="polite">' +
        '<div class="skel-head"><span class="skel-dots" aria-hidden="true"><span></span><span></span><span></span></span>' +
        '<span class="skel-label">' + escapeHtml(label || 'Running — grounding in cited sources…') + '</span></div>' +
        '<div class="skel-bar w-90"></div><div class="skel-bar w-75"></div><div class="skel-bar w-60"></div><div class="skel-bar w-45"></div>' +
        '</div>';
    }

    function renderError(err) {
      if (err && err.status == null && window.console) console.error('[opora-edge tool error]', err);
      var c = errorCopy(err && err.status != null ? err.status : 0, err && err.message);
      resultEl.hidden = false;
      // 400 validation: surface inline near a field if it maps, else show block
      if (c.validation) {
        var mapped = mapServerError(err.message);
        if (mapped) {
          var errEl = form.querySelector('[data-err="' + mapped + '"]');
          var fld = form.querySelector('[name="' + mapped + '"]');
          if (errEl) errEl.textContent = err.message;
          if (fld) { fld.classList.add('invalid'); fld.focus(); }
        }
      }
      resultEl.innerHTML =
        '<div class="result-error"><span class="err-icon" aria-hidden="true">!</span>' +
        '<div class="err-text"><b>' + escapeHtml(c.title) + '.</b> ' + escapeHtml(c.body) +
        (c.gate ? '' : '<div class="err-retry"><button type="button" class="btn-text ink">Try again</button></div>') +
        '</div></div>';
      var retry = resultEl.querySelector('.err-retry button');
      if (retry) retry.addEventListener('click', function () { resultEl.hidden = true; var first = form.querySelector('input,select,textarea'); if (first) first.focus(); });
      if (c.gate) setTimeout(openGate, 350);
    }

    function mapServerError(msg) {
      if (!msg) return null;
      var fields = ['sqft', 'state', 'states', 'business', 'bid_text', 'rfp_text', 'bid_price_total', 'lost_account_name', 'employee_count'];
      for (var i = 0; i < fields.length; i++) if (msg.toLowerCase().indexOf(fields[i].replace('_', ' ')) >= 0 || msg.toLowerCase().indexOf(fields[i]) >= 0) return fields[i];
      return null;
    }

    function renderResult(data, ms) {
      resultEl.hidden = false;
      var head = '<div class="result-head"><span class="result-dot" aria-hidden="true"></span><h4>Result</h4>' +
        (ms ? '<span class="result-time">' + (ms / 1000).toFixed(1) + 's</span>' : '') + '</div>';
      var body = renderData(data);
      resultEl.innerHTML = head + '<div class="result-body">' + body + '</div>';
      wireResultCites(resultEl);
    }
  });

  /* ── Generic data renderer: turns any worker JSON into nice blocks ── */
  function renderData(data) {
    if (data == null) return '<div class="result-block"><p>No result returned.</p></div>';
    if (typeof data === 'string') return '<div class="result-block"><div class="result-md">' + renderMarkdown(data) + '</div></div>';

    var blocks = [];
    var citations = collectCitations(data);

    Object.keys(data).forEach(function (key) {
      var val = data[key];
      if (val == null || val === '') return;
      if (/^(citations|sources|references|_meta|meta|request_id|id|ts|timestamp)$/i.test(key)) return;
      blocks.push(renderField(key, val));
    });

    if (citations.length) {
      blocks.push('<div class="result-block"><div class="result-block-title">Sources · ' + citations.length + '</div>' +
        '<div class="result-sources">' + citations.map(function (c, i) {
          return '<span class="src-chip" title="' + escapeHtml(c.detail || c.name) + '"><span class="src-num">' + (i + 1) + '</span><span class="src-name">' + escapeHtml(c.name) + '</span></span>';
        }).join('') + '</div></div>');
    }
    return blocks.join('') || '<div class="result-block"><p>Done.</p></div>';
  }

  function titleize(key) { return key.replace(/_/g, ' ').replace(/\bmarkdown\b/i, '').replace(/\b\w/g, function (m) { return m.toUpperCase(); }).trim(); }

  function renderField(key, val) {
    var title = titleize(key);

    // markdown string fields
    if (typeof val === 'string') {
      if (/markdown/i.test(key) || val.length > 80 || /[#*\n]/.test(val)) {
        return '<div class="result-block"><div class="result-block-title">' + escapeHtml(title) + '</div><div class="result-md">' + renderMarkdown(val) + '</div></div>';
      }
      return '<div class="result-block"><div class="result-block-title">' + escapeHtml(title) + '</div><dl class="result-kv"><dt>' + escapeHtml(title) + '</dt><dd>' + escapeHtml(val) + '</dd></dl></div>';
    }

    if (typeof val === 'number' || typeof val === 'boolean') {
      return '<div class="result-block"><dl class="result-kv"><dt>' + escapeHtml(title) + '</dt><dd class="mono">' + escapeHtml(String(val)) + '</dd></dl></div>';
    }

    // arrays
    if (Array.isArray(val)) {
      if (!val.length) return '';
      // array of objects → Q/A style
      if (typeof val[0] === 'object') {
        var items = val.map(function (o) {
          var keys = Object.keys(o);
          // pick a primary "question"/"label"
          var primaryKey = keys.find(function (k) { return /question|title|label|name|item|topic|requirement/i.test(k); }) || keys[0];
          var primary = o[primaryKey];
          var rest = keys.filter(function (k) { return k !== primaryKey && o[k] != null && o[k] !== ''; })
            .map(function (k) { return '<b>' + escapeHtml(titleize(k)) + ':</b> ' + escapeHtml(typeof o[k] === 'object' ? JSON.stringify(o[k]) : String(o[k])); }).join('<br>');
          return '<div class="result-qa-item"><div class="result-qa-q">' + escapeHtml(typeof primary === 'object' ? JSON.stringify(primary) : String(primary)) + '</div>' +
            (rest ? '<div class="result-qa-meta">' + rest + '</div>' : '') + '</div>';
        }).join('');
        return '<div class="result-block"><div class="result-block-title">' + escapeHtml(title) + '</div><div class="result-qa">' + items + '</div></div>';
      }
      // array of strings → bullet list
      var lis = val.map(function (s) { return '<li>' + escapeHtml(String(s)) + '</li>'; }).join('');
      return '<div class="result-block"><div class="result-block-title">' + escapeHtml(title) + '</div><div class="result-md"><ul>' + lis + '</ul></div></div>';
    }

    // object: detect numeric "metrics" (e.g. compensation_analysis with range_low/mid/high, margin %)
    if (typeof val === 'object') {
      var numericKeys = Object.keys(val).filter(function (k) { return typeof val[k] === 'number'; });
      var metricsHtml = '';
      if (numericKeys.length >= 2 && numericKeys.length <= 6) {
        metricsHtml = '<div class="result-metrics">' + numericKeys.map(function (k) {
          var v = val[k];
          var cls = '';
          if (/margin|profit|healthy|ok/i.test(k) && v < 0) cls = 'bad';
          else if (/margin|profit/i.test(k)) cls = v >= 15 ? 'ok' : (v >= 5 ? 'warn' : 'bad');
          var disp = /price|cost|low|mid|high|range|wage|total|amount|labor|supplies|equipment|overhead/i.test(k) && !/percent|pct|rate/i.test(k)
            ? '$' + Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })
            : (/percent|pct|margin|rate/i.test(k) ? Number(v).toFixed(1) + '%' : Number(v).toLocaleString());
          return '<div class="result-metric"><span class="rm-label">' + escapeHtml(titleize(k)) + '</span><span class="rm-val ' + cls + '">' + disp + '</span></div>';
        }).join('') + '</div>';
      }
      var rest = Object.keys(val).filter(function (k) { return numericKeys.indexOf(k) < 0 && val[k] != null && val[k] !== ''; });
      var restHtml = rest.map(function (k) {
        var v = val[k];
        if (typeof v === 'string' && (/markdown/i.test(k) || v.length > 80)) return '<div class="result-md" style="margin-top:10px"><b>' + escapeHtml(titleize(k)) + '</b>' + renderMarkdown(v) + '</div>';
        if (typeof v === 'object') return renderField(k, v);
        return '<dl class="result-kv"><dt>' + escapeHtml(titleize(k)) + '</dt><dd>' + escapeHtml(String(v)) + '</dd></dl>';
      }).join('');
      return '<div class="result-block"><div class="result-block-title">' + escapeHtml(title) + '</div>' + metricsHtml + restHtml + '</div>';
    }
    return '';
  }

  function collectCitations(data) {
    var out = [];
    var arr = data.citations || data.sources || data.references;
    if (Array.isArray(arr)) arr.forEach(function (c) {
      var name = typeof c === 'string' ? c : (c.title || c.name || c.source || c.domain || c.bls_citation || c.url || '');
      var detail = typeof c === 'string' ? '' : (c.snippet || c.detail || c.description || c.url || '');
      if (name) out.push({ name: String(name).slice(0, 120), detail: detail });
    });
    // also harvest *_citation string fields
    Object.keys(data).forEach(function (k) {
      if (/citation$/i.test(k) && typeof data[k] === 'string' && data[k]) out.push({ name: data[k].slice(0, 120), detail: '' });
      if (typeof data[k] === 'object' && data[k] && data[k].bls_citation) out.push({ name: String(data[k].bls_citation).slice(0, 120), detail: '' });
    });
    // de-dupe
    var seen = {}; return out.filter(function (c) { if (seen[c.name]) return false; seen[c.name] = 1; return true; });
  }

  function wireResultCites() { /* tooltips are CSS-driven; nothing to wire */ }

  /* ── shared POST helper (JSON) ── */
  function postJson(endpoint, payload) {
    return fetch(API_BASE + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.text().then(function (t) {
        if (!res.ok) {
          var msg = '';
          try { var j = JSON.parse(t); msg = j.error || j.message || ''; } catch (e) {}
          var err = new Error(msg); err.status = res.status; throw err;
        }
        try { return JSON.parse(t); } catch (e) { return t; }
      });
    }, function () {
      var err = new Error('network'); err.status = 0; throw err;
    });
  }

})();